import Vue from 'vue';
import VueCookies from 'vue-cookies';
import { mock$T } from '@pendo/i18n';
import { PendoButton, PendoForm, PendoFormItem, PendoInput, PendoInputPassword, PendoNotification, PendoCard, PendoIcon, PendoCheckbox, PendoTooltip, PendoLoadingIndicator, PendoPopover, PendoAlert } from '@pendo/components';
import kebabCase from 'lodash/kebabCase';
import { http, initializeHttpWrapper as initializeHttpWrapper$1 } from '@pendo/http';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';

//
//
//
//
//
//
//
//
//
//
//
var script$e = {
  name: 'LoginBackground',
  props: {
    isNight: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#F4F4F7'
    }
  },
  computed: {
    computedBackgroundColor() {
      if (this.isNight) {
        return '#2A2C35';
      }

      return this.backgroundColor;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: [{
      'is-night': _vm.isNight
    }, 'login-background'],
    style: {
      'background-color': _vm.computedBackgroundColor
    }
  }, [_c('div', {
    staticClass: "login-logo"
  }, [_vm._t("logo")], 2), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = function (inject) {
  if (!inject) return;
  inject("data-v-5275be1e_0", {
    source: ".login-background[data-v-5275be1e]{position:fixed;top:0;right:0;bottom:0;left:0;overflow:hidden;display:flex;align-items:center;justify-content:center}@media only screen and (max-width:767px){.login-background[data-v-5275be1e]{display:flex;flex-direction:column;padding:35px 15px 0 15px}}.login-logo[data-v-5275be1e]{position:absolute;top:33px;left:33px}@media only screen and (max-width:767px){.login-logo[data-v-5275be1e]{align-self:center;position:relative;top:auto;left:auto}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$e = "data-v-5275be1e";
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

function getTimeOfDay(currentTime) {
  // time of day
  const h = currentTime.getHours(); // 12am -> 5:59am, 10pm -> 11:59pm (night)

  if (h >= 0 && h < 6 || h >= 22) {
    return 0;
  } // 6am -> 11:59am (morning)


  if (h >= 6 && h < 12) {
    return 1;
  } // 12pm -> 5:59pm (afternoon)


  if (h >= 12 && h < 18) {
    return 2;
  } // 6pm -> 9:59pm


  if (h >= 18 && h < 22) {
    return 3;
  }
}
function isNightTime(currentTime) {
  return getTimeOfDay(currentTime) === 0 || getTimeOfDay(currentTime) === 3;
}
function timeOfDayGreeting() {
  let loginGreeting = 'Hello!';
  let loginMessage = "Grab some coffee and let's get this show on the road.";
  const timeOfDay = getTimeOfDay(new Date());
  const messages = [// 0 = late night
  ['Don’t worry, we’re up with you. Tracking your application 24x7.', 'Nobody said successful products were easy. Keep on trucking!'], // 1 = morning
  ['Coffee? Check. Sticky buns? Check. User insights? Check.', 'Bright-eyed, bushy-tailed and ready to rock some data!'], // 2 = afternoon
  ['Do your users slow down after lunch? Let’s find out.', 'Beat the post-lunch food coma with some invigorating user guidance.'], // 3 = evening
  ["Good evening! We're still up and ready to explore some user insights with you."]];
  const greetings = ['Working late?', 'Good morning!', 'Good afternoon!', 'Good evening!'];
  const random = Math.floor(Math.random() * messages[timeOfDay].length);
  loginGreeting = greetings[timeOfDay];
  loginMessage = messages[timeOfDay][random];
  return {
    loginGreeting,
    loginMessage
  };
}
function getStringBetween(str, start, end) {
  const regex = new RegExp(`${start}(.*)${end}`);
  const result = str.match(regex);
  return result ? result[1] : '';
}
function getDomainForLoginIdCookie(urlHostname) {
  if (urlHostname.includes('.pendo-dev.com') || urlHostname.includes('.pendo.io')) {
    const urlStrings = urlHostname.split('.');

    if (urlStrings[0] === 'app' || urlStrings[0] === 'adopt') {
      urlStrings[0] = '';
      urlHostname = urlStrings.join('.');
    }
  }

  return urlHostname;
}
const inviteConfirmationErrors = Object.freeze({
  INVALID: 'invalid invitation data',
  EXPIRED: 'invitation expired',
  KEY_ISSUE: 'invalid invitation key'
});
function routeToError(_ref) {
  let {
    statusCode,
    errorMsg
  } = _ref;

  switch (statusCode) {
    case 400:
      if (errorMsg === inviteConfirmationErrors.INVALID) {
        window.location.assign(`/${kebabCase(inviteConfirmationErrors.INVALID)}`);
      } else if (errorMsg === inviteConfirmationErrors.EXPIRED) {
        window.location.assign(`/${kebabCase(inviteConfirmationErrors.EXPIRED)}`);
      } else {
        window.location.assign('/404');
      }

      break;

    case 422:
      window.location.assign(`/${kebabCase(inviteConfirmationErrors.KEY_ISSUE)}`);
      break;

    default:
      window.location.assign('/404');
      break;
  }
}

//
var script$d = {
  name: 'LoginTemplate',
  components: {
    PendoButton,
    PendoForm,
    PendoFormItem,
    PendoInput,
    PendoInputPassword,
    LoginBackground: __vue_component__$e
  },
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    description: {
      type: String,
      default: 'This is the description.'
    },
    buttonText: {
      type: String,
      default: 'Button Text'
    },
    inputType: {
      type: String,
      default: 'text'
    },
    formInputLabel: {
      type: String,
      default: 'Some Label'
    },
    theme: {
      type: String,
      default: 'app'
    },
    time: {
      type: Date,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    },
    isWhiteLabel: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loginError: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      callValidate: false,
      model: {
        [this.inputType]: this.value
      }
    };
  },

  computed: {
    isNight() {
      const useNightMode = this.time ? isNightTime(this.time) : false;
      return !this.isWhiteLabel && useNightMode;
    },

    textColor() {
      const dayTextColor = '#2A2C35';
      const nightTextColor = '#F4F4F7';
      return this.isNight ? nightTextColor : dayTextColor;
    },

    hasFormSlot() {
      return !!this.$slots.form;
    }

  },
  methods: {
    onClick() {
      this.callValidate = true;
      this.$emit('on-click', this.model[this.inputType]);
    },

    handleInvalidForm() {
      this.callValidate = false;
      this.$emit('invalid-form');
    },

    handleValidForm() {
      this.callValidate = false;
      this.$emit('form-validated');
    },

    onInput() {
      this.$emit('on-input', this.model[this.inputType]);
    },

    onFocus() {
      this.$emit('on-focus');
    }

  }
};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', {
    attrs: {
      "is-night": _vm.isNight
    },
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm.isNight ? _vm._t("nightLogo") : _vm._t("logo")];
      },
      proxy: true
    }], null, true)
  }, [_vm._v(" "), _c('div', {
    staticClass: "center-block",
    style: {
      color: _vm.textColor
    }
  }, [_c('h1', {
    staticClass: "center-block__header",
    class: {
      'center-block__header-night': _vm.isNight
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "center-block__inner-width-wrapper"
  }, [_c('p', {
    staticClass: "center-block__helper-text"
  }, [_vm._v("\n                " + _vm._s(_vm.description) + "\n            ")]), _vm._v(" "), _vm._t("form"), _vm._v(" "), !_vm.hasFormSlot ? _c('pendo-form', {
    staticClass: "center-block__form",
    class: {
      'center-block__form-night': _vm.isNight
    },
    attrs: {
      "model": _vm.model,
      "call-validate": _vm.callValidate
    },
    on: {
      "invalidForm": _vm.handleInvalidForm,
      "formValidated": _vm.handleValidForm
    }
  }, [_c('pendo-form-item', {
    attrs: {
      "data-cy": "login-template--input",
      "rules": _vm.rules,
      "prop": _vm.inputType,
      "label": _vm.formInputLabel
    }
  }, [_vm.inputType !== 'password' ? _c('pendo-input', {
    attrs: {
      "type": _vm.inputType
    },
    on: {
      "focus": _vm.onFocus,
      "input": _vm.onInput
    },
    model: {
      value: _vm.model[_vm.inputType],
      callback: function ($$v) {
        _vm.$set(_vm.model, _vm.inputType, $$v);
      },
      expression: "model[inputType]"
    }
  }) : _vm._e(), _vm._v(" "), _vm.inputType === 'password' ? _c('pendo-input-password', {
    ref: "passwordInput",
    on: {
      "focus": _vm.onFocus,
      "input": _vm.onInput
    },
    model: {
      value: _vm.model[_vm.inputType],
      callback: function ($$v) {
        _vm.$set(_vm.model, _vm.inputType, $$v);
      },
      expression: "model[inputType]"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.loginError ? _c('div', {
    staticClass: "center-block__login-error"
  }, [_vm._v("\n                    " + _vm._s(_vm.loginError) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('pendo-button', {
    staticClass: "center-block__button",
    attrs: {
      "data-cy": "login-template--reset-link",
      "loading": _vm.loading,
      "theme": _vm.theme,
      "type": "primary",
      "block": "",
      "label": _vm.buttonText
    },
    on: {
      "click": _vm.onClick
    }
  }), _vm._v(" "), _vm._t("formItems", null, {
    "isNight": _vm.isNight
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("afterFormItems")], 2)])]);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = function (inject) {
  if (!inject) return;
  inject("data-v-5b97c887_0", {
    source: ".center-block[data-v-5b97c887]{width:33%;margin:0 auto;min-width:500px}@media only screen and (max-width:767px){.center-block[data-v-5b97c887]{padding-top:25px;min-width:auto;width:100%;max-width:500px}}.center-block .center-block__login-error[data-v-5b97c887]{display:flex;align-items:center;justify-content:center;margin-bottom:16px;color:#db1111;border:1px solid #db1111;border-radius:3px;background-color:rgba(219,17,17,.1);padding:4px 15px;height:50px;font-size:14px;text-align:center}.center-block .center-block__header[data-v-5b97c887]{font-family:Sora;font-weight:600;font-size:36px;line-height:42px;margin-top:0;white-space:normal;text-align:center}@media only screen and (max-width:767px){.center-block .center-block__header[data-v-5b97c887]{font-size:32px}}.center-block .center-block__header-night[data-v-5b97c887]{color:#f4f4f7}.center-block .center-block__helper-text[data-v-5b97c887]{font-size:18px;font-weight:400;margin:1em auto 2em;text-align:center}.center-block .center-block__inner-width-wrapper[data-v-5b97c887]{margin:0 auto;max-width:380px;min-width:auto}.center-block[data-v-5b97c887] .pendo-input__field{background:0 0!important}.center-block .center-block__form[data-v-5b97c887] .pendo-form-item__label::after{content:\"\"}.center-block .center-block__form-night[data-v-5b97c887]  .pendo-form-item__label,.center-block .center-block__form-night[data-v-5b97c887]  .pendo-input-password__visibility-toggle{color:#f4f4f7}.center-block .center-block__form-night[data-v-5b97c887] .pendo-input__field:hover{border-color:#fff}.center-block .center-block__form-night[data-v-5b97c887] .pendo-form-item.is-error .pendo-input__field{border-color:#ff7f74}.center-block .center-block__form-night[data-v-5b97c887] .pendo-form-item.is-required .pendo-form-item__label:after,.center-block .center-block__form-night[data-v-5b97c887] .pendo-form-item__error{color:#ff7f74}.center-block .center-block__form-night .center-block__login-error[data-v-5b97c887]{border-color:#ff7f74;background-color:rgba(255,127,116,.1)}.center-block .center-block__form-night .center-block__login-error[data-v-5b97c887],.center-block .center-block__form-night[data-v-5b97c887]  .pendo-checkbox,.center-block .center-block__form-night[data-v-5b97c887]  input{color:#fff}.center-block[data-v-5b97c887] .pendo-form-item{text-align:left}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$d = "data-v-5b97c887";
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

function sendResetPasswordLink(email) {
  return http.post('/api/signup/user/pwresetrequest', {
    email
  }).then(res => res.data);
}
function resetPassword(inviteKey, password) {
  return http.post(`/api/signup/user/resetpassword/${inviteKey}`, {
    password
  });
}
function login(username, password, queryString) {
  return http.post(`/login${queryString}`, {
    username,
    password
  }).then(res => res.data);
}
function getAuthType(username) {
  return http.get(`/login/resolveauth?username=${encodeURIComponent(username)}`).then(res => res.data);
}
function createWithPassword(inviteKey, password) {
  return http.post(`/api/signup/user/create/${inviteKey}`, {
    password
  }).then(res => res.data);
}
function createWithGoogle(inviteKey) {
  return http.post('/api/signup/user/googlelogin', {
    inviteKey
  }).then(res => res.data);
}
function confirmInvitation(inviteKey) {
  return http.get(`/api/signup/invitation/confirm/${inviteKey}`);
}
function getInvitationInfo(inviteKey) {
  return http.get(`/api/signup/invitation/query/${inviteKey}`);
}

//
var script$c = {
  name: 'ForgotPassword',
  components: {
    LoginTemplate: __vue_component__$d
  },
  props: {
    /**
     * Time of the day
     */
    time: {
      type: Date,
      default: () => new Date()
    },

    /**
     * Email of the user
     */
    email: {
      type: String,
      default: ''
    },

    /**
     * If the domain is a white label domain
     */
    isWhiteLabel: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      description: "Please enter your email address and we'll send you a link to reset your password.",
      buttonText: this.$t('Send Email'),
      rules: [{
        type: 'email',
        message: this.$t('Please input a valid email address'),
        trigger: ['blur']
      }, {
        required: true,
        message: this.$t('Email address is required'),
        trigger: ['blur', 'change']
      }],
      initialEmail: '',
      emailToBeSent: ''
    };
  },

  created() {
    const emailString = window.location.search;

    if (this.email) {
      this.initialEmail = this.email;
    } else if (emailString) {
      const emailParam = new URLSearchParams(emailString).get('email');
      this.initialEmail = emailParam ? decodeURIComponent(emailParam) : '';
    }

    this.emailToBeSent = this.initialEmail;
  },

  methods: {
    onClick(val) {
      this.$emit('on-click', val);
    },

    onInput(val) {
      this.emailToBeSent = val;
      this.$emit('on-input', val);
    },

    handleInvalidForm() {
      this.$emit('invalid-form');
    },

    async handleValidForm() {
      await this.callSendResetPasswordLink();
      this.$emit('form-validated');
    },

    async callSendResetPasswordLink() {
      try {
        await sendResetPasswordLink(this.emailToBeSent);
        PendoNotification({
          type: 'success',
          message: 'An email with next steps has been sent.',
          duration: 10000,
          customClass: 'forgot-pw-success'
        });
      } catch {
        PendoNotification({
          type: 'error',
          message: 'An error occured',
          duration: 10000,
          customClass: 'forgot-pw-error'
        });
      }
    }

  }
};

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-template', {
    attrs: {
      "title": "Forgot your password?",
      "description": _vm.description,
      "button-text": "Send email",
      "input-type": "email",
      "form-input-label": "Email address",
      "time": _vm.time,
      "rules": _vm.rules,
      "value": _vm.initialEmail,
      "is-white-label": _vm.isWhiteLabel
    },
    on: {
      "invalid-form": _vm.handleInvalidForm,
      "form-validated": _vm.handleValidForm,
      "on-click": _vm.onClick,
      "on-input": _vm.onInput
    },
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }, {
      key: "nightLogo",
      fn: function () {
        return [_vm._t("nightLogo")];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = undefined;
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

//
var script$b = {
  name: 'SuccessEmailCard',
  components: {
    PendoCard,
    PendoIcon
  }
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-card', {
    staticClass: "success-email-card",
    attrs: {
      "width": "400px",
      "body-min-height": "0",
      "footer-min-height": "0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('div', {
          staticClass: "success-email-card__mail-icon-wrapper"
        }, [_c('pendo-icon', {
          staticClass: "success-email-card__mail-icon",
          attrs: {
            "type": "mail",
            "stroke": "#128297"
          }
        })], 1), _vm._v(" "), _c('h2', {
          staticClass: "success-email-card__title"
        }, [_vm._v("\n            Great, please verify your email.\n        ")]), _vm._v(" "), _c('p', {
          staticClass: "success-email-card__description"
        }, [_vm._v("\n            We emailed you a link to verify your email address and create your password. You should receive it\n            shortly. Don't forget to check your spam folder.\n        ")])];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = function (inject) {
  if (!inject) return;
  inject("data-v-1ea450ab_0", {
    source: ".success-email-card[data-v-1ea450ab]{border:1px solid #dadce5}.success-email-card[data-v-1ea450ab] .pendo-card__body{padding:24px}.success-email-card[data-v-1ea450ab] .pendo-card__footer{padding:16px 24px}.success-email-card__mail-icon-wrapper[data-v-1ea450ab]{display:flex;align-items:center;justify-content:center;width:50px;border-radius:50%;height:50px;background-color:#d9fcff}.success-email-card__title[data-v-1ea450ab]{margin:0;font-size:22px;font-weight:700;margin-top:20px;margin-bottom:10px;line-height:1.3em}.success-email-card__description[data-v-1ea450ab]{font-size:14px;line-height:1.4}@media only screen and (max-width:767px){.success-email-card[data-v-1ea450ab]{margin-top:25px}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$b = "data-v-1ea450ab";
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

//
var script$a = {
  name: 'ExpiredLinkCard',
  components: {
    PendoIcon,
    PendoButton,
    PendoCard
  },
  methods: {
    goToLogin() {
      window.location.assign('/');
    },

    requestNewLink() {
      this.$emit('request-new-link');
    }

  }
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-card', {
    staticClass: "expired-link-card",
    attrs: {
      "width": "400px",
      "shadow": "always",
      "body-min-height": "0",
      "footer-min-height": "0"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('pendo-button', {
          attrs: {
            "data-cy": "resend-request--button",
            "theme": "app",
            "type": "primary",
            "label": "Resend request",
            "block": ""
          },
          on: {
            "click": _vm.requestNewLink
          }
        }), _vm._v(" "), _c('span'), _vm._v(" "), _c('pendo-button', {
          attrs: {
            "data-cy": "return-to-login--button",
            "theme": "app",
            "type": "link",
            "label": "Return to login",
            "block": ""
          },
          on: {
            "click": _vm.goToLogin
          }
        })];
      },
      proxy: true
    }])
  }, [_c('pendo-icon', {
    staticClass: "expired-link-card__alert-circle-icon",
    attrs: {
      "type": "alert-circle",
      "stroke": "#DBA211",
      "size": "25"
    }
  }), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "expired-link-card__title"
  }, [_vm._v("\n            We're sorry, but it looks like this link has expired.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "expired-link-card__description"
  }, [_vm._v("\n            This password reset link has expired. Please try logging in again or resending the request.\n        ")])])], 1);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = function (inject) {
  if (!inject) return;
  inject("data-v-0d5094b0_0", {
    source: ".expired-link-card[data-v-0d5094b0]{border:1px solid #dadce5}.expired-link-card[data-v-0d5094b0] .pendo-card__body{padding:24px}.expired-link-card[data-v-0d5094b0] .pendo-card__footer{padding:16px 24px}[data-v-0d5094b0] .expired-link-card__alert-circle-icon svg{background:#fdefd5;padding:11px;border-radius:27px;margin-bottom:16px}.expired-link-card__title[data-v-0d5094b0]{font-size:22px;line-height:1.2}@media only screen and (max-width:767px){.expired-link-card[data-v-0d5094b0]{margin-top:25px}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$a = "data-v-0d5094b0";
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

//
var script$9 = {
  name: 'ExpiredLink',
  components: {
    LoginBackground: __vue_component__$e,
    SuccessEmailCard: __vue_component__$b,
    ExpiredLinkCard: __vue_component__$a
  },

  data() {
    return {
      requestedNewLink: false,
      email: ''
    };
  },

  created() {
    const {
      pathname
    } = window.location;

    if (pathname) {
      const rawEmail = getStringBetween(pathname, 'resetpassword/', '/expiredlink');
      this.email = decodeURIComponent(rawEmail);
    }
  },

  methods: {
    async requestNewLink() {
      try {
        await sendResetPasswordLink(this.email);
        this.requestedNewLink = true;
      } catch {
        PendoNotification({
          type: 'error',
          message: 'An error occured',
          duration: 10000,
          customClass: 'forgot-pw-error'
        });
      }

      this.$emit('request-new-link');
    }

  }
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', {
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }], null, true)
  }, [_vm._v(" "), !_vm.requestedNewLink ? _c('expired-link-card', {
    on: {
      "request-new-link": _vm.requestNewLink
    }
  }) : _vm._e(), _vm._v(" "), _vm.requestedNewLink ? _c('success-email-card') : _vm._e()], 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//
const emailCookieKey = '_pendo_login_id';
var script$8 = {
  name: 'LoginView',
  components: {
    LoginTemplate: __vue_component__$d,
    PendoCheckbox,
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  props: {
    /**
     * Time of the day
     */
    time: {
      type: Date,
      default: () => new Date()
    },

    /**
     * If the domain is a white label domain
     */
    isWhiteLabel: {
      type: Boolean,
      default: false
    },

    /**
     * Loading init call on app
     */
    loadingApp: {
      type: Boolean,
      default: false
    },
    productType: {
      type: String,
      default: 'Engage'
    }
  },

  data() {
    return {
      rules: {
        email: [{
          type: 'email',
          message: this.$t('Please input a valid email address'),
          trigger: ['blur']
        }, {
          required: true,
          message: this.$t('Email address is required'),
          trigger: ['blur', 'change']
        }],
        password: [{
          required: true,
          message: this.$t('Password is required'),
          trigger: []
        }]
      },
      user: {},
      passwordRequired: false,
      rememberMeValue: null,
      loginIdCookieValue: '',
      cookieEnabled: false,
      cookieDomain: null,
      samlDomainEnabled: false,
      loading: false,
      loginError: null
    };
  },

  computed: {
    value() {
      return this.passwordRequired ? this.user.password : this.user.email;
    },

    timeOfDayGreeting() {
      if (!this.passwordRequired) {
        return timeOfDayGreeting();
      }

      return {
        loginGreeting: this.$t('Looks like your account requires a password'),
        loginMessage: this.$t('Please enter below.')
      };
    },

    loginMessage() {
      return this.timeOfDayGreeting.loginMessage;
    },

    loginGreeting() {
      return this.timeOfDayGreeting.loginGreeting;
    },

    inputType() {
      return this.passwordRequired ? 'password' : 'email';
    },

    formInputLabel() {
      return this.passwordRequired ? this.$t('Password') : this.$t('Email Address');
    },

    baseUEUrl() {
      switch (this.productType) {
        case 'Engage':
          return 'https://app.eu.pendo.io';

        case 'Adopt':
          return 'https://adopt.eu.pendo.io';

        default:
          return 'https://app.eu.pendo.io';
      }
    },

    loginWith() {
      const here = new URL(window.location.href);
      return {
        google: `/login/google${here.search}`,
        eu: `${this.baseUEUrl}/login${here.search}`
      };
    },

    isEU() {
      return window && window.appEnvId === 'prod-eu';
    },

    queryString() {
      const here = new URL(window.location.href);
      return here.search;
    }

  },
  watch: {
    passwordRequired(isRequired) {
      if (isRequired) {
        this.$nextTick(() => {
          this.$refs.loginTemplate.$refs.passwordInput.$el.querySelector('input').focus();
        });
      }
    }

  },

  mounted() {
    window.onpopstate = () => {
      window.location.reload();
    };
  },

  created() {
    this.cookieEnabled = window.navigator.cookieEnabled;
    this.cookieDomain = this.cookieEnabled ? getDomainForLoginIdCookie(window.location.hostname) : undefined;
    this.loginIdCookieValue = this.cookieEnabled ? window.$cookies.get(emailCookieKey) : undefined;
    this.user = this.loginIdCookieValue ? {
      email: this.loginIdCookieValue
    } : {};
    this.rememberMeValue = !!this.loginIdCookieValue;
  },

  methods: {
    onInput(val) {
      if (this.passwordRequired && !val) {
        this.rules.password[0].trigger = ['change'];
      } else if (this.passwordRequired && val) {
        this.user.password = val;
        this.rules.password[0].trigger = ['blur', 'change'];
      } else {
        this.user.email = val;
      }
    },

    async handleValidForm() {
      this.loading = true;

      if (this.passwordRequired) {
        await this.login();
      } else {
        this.checkRememberMeValue();

        if (this.isWhiteLabel) {
          this.passwordRequired = true;
          this.loading = false;
          return;
        }

        await this.resolveAuthType();
        window.history.pushState({}, '');
      }
    },

    async login() {
      try {
        const data = await login(this.user.email, this.user.password, this.queryString);
        this.$emit('on-user-authenticated', data);
      } catch {
        this.loading = false;

        if (this.isWhiteLabel) {
          this.loginError = this.$t('Email or password is invalid. Please try again.');
        } else {
          this.loginError = this.$t('Email or password is invalid. Please try again or try logging in with a Google Apps account.');
        }
      }
    },

    async resolveAuthType() {
      const {
        email
      } = this.user;
      let authTypes;

      try {
        authTypes = await getAuthType(email);
      } catch {
        authTypes = null;
      }

      if (!authTypes) {
        this.passwordRequired = true;
        this.loading = false;
        return;
      }

      const {
        auth,
        samlDomain,
        samlRedirect
      } = authTypes;

      if (samlRedirect) {
        this.fetchSamlDomain();
        return;
      }

      const here = new URL(window.location.href);
      here.searchParams.set('username', email);

      if (!email) {
        this.loading = false;
        return;
      }

      switch (auth) {
        case 'saml':
          this.loginError = this.$t('You need to login with your SAML provider');
          break;

        case 'google':
          window.location.href = `/login/google${here.search}`;
          break;

        case 'feedback-saml':
          window.location.href = `/login/saml/feedback${here.search}`;
          break;

        default:
          if (samlDomain) {
            this.samlDomainEnabled = true;
          }

          this.passwordRequired = true;
      }

      this.loading = false;
    },

    fetchSamlDomain() {
      window.location.href = `/login/saml/sp/${this.user.email}${window.location.search}`;
    },

    navigateToForgotPassword() {
      const here = new URL(window.location.href);
      here.searchParams.set('email', encodeURIComponent(this.user.email));
      window.location.href = `/forgot${here.search}`;
    },

    removeErrors() {
      this.loginError = null;
    },

    changeRememberMe(val) {
      this.rememberMeValue = val;
    },

    checkRememberMeValue() {
      if (this.rememberMeValue) {
        this.setEmailAddressOnCookie();
      } else {
        this.removeEmailAddressCookie();
      }
    },

    setEmailAddressOnCookie() {
      const numDays = 100;
      const duration = new Date();
      duration.setDate(duration.getDate() + numDays);
      window.$cookies.set(emailCookieKey, this.user.email, duration.toUTCString(), null, this.cookieDomain);
    },

    removeEmailAddressCookie() {
      if (this.loginIdCookieValue) {
        window.$cookies.remove(emailCookieKey, null, this.cookieDomain);
      }
    }

  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-template', {
    ref: "loginTemplate",
    staticClass: "login-form",
    attrs: {
      "loading": _vm.loading || _vm.loadingApp,
      "title": _vm.loginGreeting,
      "description": _vm.loginMessage,
      "button-text": _vm.$t('Sign In'),
      "form-input-label": _vm.formInputLabel,
      "input-type": _vm.inputType,
      "time": _vm.time,
      "rules": _vm.rules[_vm.inputType],
      "value": _vm.value,
      "login-error": _vm.loginError,
      "is-white-label": _vm.isWhiteLabel
    },
    on: {
      "form-validated": _vm.handleValidForm,
      "on-input": _vm.onInput,
      "on-focus": _vm.removeErrors
    },
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }, {
      key: "nightLogo",
      fn: function () {
        return [_vm._t("nightLogo")];
      },
      proxy: true
    }, {
      key: "formItems",
      fn: function (ref) {
        var isNight = ref.isNight;
        return [_c('div', {
          staticClass: "pendo-login-form",
          class: {
            'pendo-login-form-night': isNight
          }
        }, [_vm.passwordRequired ? _c('a', {
          staticClass: "pendo-login-form__forgot-link",
          class: {
            'pendo-login-form-night__forgot-link': isNight
          },
          attrs: {
            "tabindex": "0"
          },
          on: {
            "keyup": function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
                return null;
              }

              return _vm.navigateToForgotPassword.apply(null, arguments);
            },
            "click": _vm.navigateToForgotPassword
          }
        }, [_vm._v("Forgot your password?")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "pendo-login-form__remember-me",
          class: {
            'pendo-login-form-night__remember-me': isNight
          }
        }, [_vm.cookieEnabled && !_vm.passwordRequired ? _c('pendo-checkbox', {
          attrs: {
            "value": _vm.rememberMeValue,
            "label": _vm.$t('Remember Me')
          },
          on: {
            "change": _vm.changeRememberMe
          }
        }) : _vm._e()], 1), _vm._v(" "), !_vm.isWhiteLabel ? _c('div', {
          staticClass: "pendo-login-form__option-separator",
          class: {
            'pendo-login-form-night__option-separator': isNight
          }
        }, [_vm._v("\n                OR\n            ")]) : _vm._e(), _vm._v(" "), _vm.samlDomainEnabled ? _c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              content: "Clicking this will allow for you to login to Pendo via your organization's SSO.",
              arrow: true,
              multiline: true
            },
            expression: "{\n                    content: `Clicking this will allow for you to login to Pendo via your organization's SSO.`,\n                    arrow: true,\n                    multiline: true\n                }"
          }],
          staticClass: "pendo-login-form__login-saml",
          attrs: {
            "theme": "app",
            "type": "secondary",
            "block": ""
          },
          on: {
            "click": _vm.fetchSamlDomain
          }
        }, [_vm._v("\n                Use Single-Sign On\n            ")]) : _vm._e(), _vm._v(" "), !_vm.isWhiteLabel ? _c('a', {
          staticClass: "pendo-login-form__google-login",
          attrs: {
            "target": "_self",
            "href": _vm.loginWith.google
          }
        }) : _vm._e(), _vm._v(" "), !_vm.isWhiteLabel && !_vm.isEU ? _c('div', {
          staticClass: "pendo-login-form__eu-login-link",
          class: {
            'pendo-login-form-night__eu-login-link': isNight
          }
        }, [_c('span', [_vm._v(" If you have an EU Pendo subscription "), _c('a', {
          attrs: {
            "href": _vm.loginWith.eu
          }
        }, [_vm._v("sign in here")])])]) : _vm._e()], 1)];
      }
    }, {
      key: "afterFormItems",
      fn: function () {
        return [_vm._t("afterFormItems")];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-f3da0762_0", {
    source: ".pendo-login-form__option-separator{font:400 14px/1em Inter;color:#9a9ca5;margin:30px auto;text-align:center}.pendo-login-form__forgot-link{font-style:italic;font-weight:300;font-size:12px;line-height:1.5em;margin-top:5px;text-align:left;color:#6a6c75!important;display:block;width:fit-content}.pendo-login-form__forgot-link:focus,.pendo-login-form__forgot-link:hover{outline:0;text-decoration:none;color:#1a1c25!important;cursor:pointer}.pendo-login-form__remember-me{margin:10px 0;text-align:left}.pendo-login-form__login-saml{margin-bottom:16px;background-color:#fff;color:#6a6c75;box-shadow:0 2px 2px 0 rgba(0,0,0,.24),0 0 2px 0 rgba(0,0,0,.12)}.pendo-login-form__login-saml:hover{background-color:#fff;color:#6a6c75}.pendo-login-form__google-login{margin-top:none;display:inherit;width:inherit;height:40px;background:#fff center no-repeat url(https://cdn.pendo.io/img/google-signin.svg);border-radius:3px;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.24),0 0 2px 0 rgba(0,0,0,.12)}.pendo-login-form__google-login:hover{cursor:pointer;background-color:#f4f4f7;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.24),0 0 2px 0 rgba(0,0,0,.12)}.pendo-login-form__eu-login-link{font-size:14px;line-height:40px;text-align:center}.pendo-login-form-night__option-separator{color:#fff}.pendo-login-form-night__eu-login-link a{color:#fff}.pendo-login-form-night__remember-me .pendo-checkbox__input.is-checked+.pendo-checkbox__label,.pendo-login-form-night__remember-me .pendo-checkbox__label{color:#fff}.pendo-login-form-night__forgot-link{color:#babcc5!important}.pendo-login-form-night__forgot-link:focus,.pendo-login-form-night__forgot-link:hover{color:#f8f8f9!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$8 = undefined;
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

//
var script$7 = {
  name: 'NoActiveSubs',
  components: {
    LoginBackground: __vue_component__$e,
    PendoButton
  },
  props: {
    productType: {
      type: String,
      required: true
    }
  },
  computed: {
    getProductLabel() {
      if (this.productType === 'adopt') {
        return 'Engage';
      }

      return 'Adopt';
    },

    productTitle() {
      return capitalize(this.productType);
    }

  },
  methods: {
    logout() {
      this.$emit('logout');
    },

    navigateToProduct() {
      this.$emit('navigateToProduct');
    }

  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', {
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }], null, true)
  }, [_c('div', {
    staticClass: "no-active-subs"
  }, [_c('img', {
    staticClass: "no-active-subs__image",
    attrs: {
      "src": "https://cdn.pendo.io/img/login-account-not-found.svg"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "no-active-subs__header"
  }, [_vm._v("\n            " + _vm._s(_vm.productTitle) + " account not found\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "no-active-subs__helper-text"
  }, [_vm._v("\n            The email entered isn't associated with an active " + _vm._s(_vm.productTitle) + " subscription. If you're trying to\n            access " + _vm._s(_vm.getProductLabel) + ", click the button below.\n        ")]), _vm._v(" "), _c('pendo-button', {
    staticClass: "no-active-subs__product-button",
    attrs: {
      "theme": "app",
      "label": "Sign into " + _vm.getProductLabel
    },
    on: {
      "click": _vm.navigateToProduct
    }
  }), _vm._v(" "), _c('pendo-button', {
    staticClass: "no-active-subs__sign-out-button",
    attrs: {
      "label": "Sign out",
      "type": "secondary"
    },
    on: {
      "click": _vm.logout
    }
  })], 1)]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-9b0f97a0_0", {
    source: ".no-active-subs[data-v-9b0f97a0]{display:flex;align-items:center;flex-direction:column}.no-active-subs__image[data-v-9b0f97a0]{width:300px;margin:40px 0}@media only screen and (max-width:767px){.no-active-subs__image[data-v-9b0f97a0]{margin-top:50px}}.no-active-subs__header[data-v-9b0f97a0]{font-family:Sora;font-weight:600;font-size:36px;text-align:center;margin:0}@media only screen and (max-width:767px){.no-active-subs__header[data-v-9b0f97a0]{font-size:32px}}.no-active-subs__helper-text[data-v-9b0f97a0]{font-size:18px;font-weight:400;margin:1em auto 2em;text-align:center;width:600px}.no-active-subs__product-button[data-v-9b0f97a0]{width:200px}.no-active-subs__sign-out-button[data-v-9b0f97a0]{margin:10px;width:200px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$7 = "data-v-9b0f97a0";
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

//
var script$6 = {
  name: 'InvitationError',
  components: {
    LoginBackground: __vue_component__$e,
    PendoButton
  },
  props: {
    errorType: {
      type: String,
      default: null
    }
  },
  computed: {
    invitationErrorPath() {
      const pathnameStrings = window.location.pathname.split('/');

      if (pathnameStrings.length > 1) {
        return this.errorType || pathnameStrings[1];
      }

      return this.errorType;
    },

    invitationErrorData() {
      switch (this.invitationErrorPath) {
        case 'invalid-invitation-data':
          return {
            statusCode: 400,
            header: 'Invalid Invitation Data',
            message: 'This invitation is invalid'
          };

        case 'invalid-invitation-key':
          return {
            statusCode: 422,
            header: 'Invalid Invitation Key',
            message: 'Your link is broken'
          };

        case 'invitation-expired':
          return {
            statusCode: 400,
            header: 'Invitation Expired',
            message: 'This invitation has expired'
          };

        default:
          return {
            statusCode: 404,
            message: null,
            header: 'The page you are looking for has been moved, deleted, or does not exist. Please try again.'
          };
      }
    }

  },
  methods: {
    navigateHome() {
      window.location.assign('/');
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', [_c('div', {
    staticClass: "invitation-error four-oh-four"
  }, [_c('h1', [_vm._v(_vm._s(_vm.invitationErrorData.statusCode))]), _vm._v(" "), _c('h3', {
    attrs: {
      "data-cy": "invitation-error-message"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.invitationErrorData.header) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.invitationErrorData.message))]), _vm._v(" "), _c('pendo-button', {
    attrs: {
      "label": "Go home",
      "type": "secondary"
    },
    on: {
      "click": _vm.navigateHome
    }
  })], 1)]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-753da848_0", {
    source: ".four-oh-four[data-v-753da848]{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);text-align:center}.four-oh-four h1[data-v-753da848]{font-size:80px;font-weight:900;color:#ff4876;margin:0 auto;line-height:1.2em}.four-oh-four h3[data-v-753da848]{margin:0 auto 1em;font-size:24px;line-height:1.3em;font-weight:300;color:#2a2c35}.four-oh-four p[data-v-753da848]{color:#2a2c35;margin:0 0 10px;font-size:14px;line-height:1.3em}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$6 = "data-v-753da848";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$5 = {};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "109",
      "height": "95",
      "viewBox": "0 0 109 95",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M53.1463 23.2015C53.6837 22.9328 54.3164 22.9328 54.8538 23.2015L73.9443 32.747C74.5911 33.0704 74.9996 33.7314 74.9996 34.4546C74.9996 35.1777 74.5911 35.8387 73.9443 36.1621L54.8538 45.7076C54.3164 45.9763 53.6837 45.9763 53.1463 45.7076L34.0558 36.1621C33.409 35.8387 33.0005 35.1777 33.0005 34.4546C33.0005 33.7314 33.409 33.0704 34.0558 32.747L53.1463 23.2015ZM39.1783 34.4546L54 41.8656L68.8218 34.4546L54 27.0435L39.1783 34.4546ZM33.202 52.6917C33.6735 51.7486 34.8202 51.3664 35.7632 51.8379L54 60.9565L72.2368 51.8379C73.1798 51.3664 74.3265 51.7486 74.798 52.6917C75.2696 53.6347 74.8873 54.7815 73.9443 55.253L54.8538 64.7985C54.3163 65.0672 53.6837 65.0672 53.1462 64.7985L34.0557 55.253C33.1127 54.7815 32.7304 53.6347 33.202 52.6917ZM35.7632 42.2924C34.8202 41.8209 33.6735 42.2032 33.202 43.1462C32.7304 44.0893 33.1127 45.236 34.0557 45.7075L53.1462 55.253C53.6837 55.5217 54.3163 55.5217 54.8538 55.253L73.9443 45.7075C74.8873 45.236 75.2696 44.0893 74.798 43.1462C74.3265 42.2032 73.1798 41.8209 72.2368 42.2924L54 51.411L35.7632 42.2924Z",
      "fill": "#128297"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0.1",
      "d": "M93.1062 12.4059C101.156 19.6352 107.024 29.1599 107.935 39.5033C108.836 49.7137 103.871 59.3512 98.0111 68.044C92.3277 76.4751 84.7394 83.4806 75.2051 88.0572C65.1916 92.8637 54.0345 96.316 42.9282 94.4843C31.6213 92.6195 21.9791 86.0194 14.4088 78.0302C6.92007 70.127 2.23754 60.4043 0.761634 49.9842C-0.74353 39.3575 -0.508323 27.8387 6.04806 19.0021C12.4067 10.432 24.1284 7.53766 34.7575 4.1648C44.4469 1.09015 54.3421 -0.96618 64.4685 0.464045C75.0793 1.96269 85.4054 5.48945 93.1062 12.4059Z",
      "fill": "#128297"
    }
  })]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
var script$4 = {
  name: 'AcceptInvite',
  components: {
    LoginBackground: __vue_component__$e,
    ConfirmationIcon: __vue_component__$5,
    PendoCard,
    PendoButton,
    PendoLoadingIndicator
  },
  props: {
    storybookMock: {
      type: Boolean,
      default: false
    },
    brandName: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      encodedKey: null,
      parsedKey: null,
      content: {
        title: "You've been invited to a new subscription in",
        button: 'Accept invite to subscription',
        subtitle: 'Accept the invite in order to be added to the subscription'
      },
      acceptingInvitation: false,
      isLoading: false
    };
  },

  computed: {
    subscriptionName() {
      return get(this, 'parsedKey.SubscriptionDisplayName', 'Default');
    },

    inviteKey() {
      const pathnameStrings = window.location.pathname.split('/');

      if (pathnameStrings.length > 4) {
        return pathnameStrings[4];
      }

      return null;
    },

    searchString() {
      return window.location.search || '';
    },

    productNameTitleMessage() {
      const productName = this.brandName || 'Pendo';
      return `${this.content.title} ${productName}:`;
    }

  },

  async created() {
    var _this$inviteKey;

    if (this.storybookMock) {
      return;
    }

    this.isLoading = true;
    this.encodedKey = (_this$inviteKey = this.inviteKey) === null || _this$inviteKey === void 0 ? void 0 : _this$inviteKey.replace(/\s/gm, '');

    try {
      const response = await getInvitationInfo(this.encodedKey);
      this.parsedKey = get(response, 'data');
      this.isLoading = false;
    } catch (error) {
      const {
        data,
        status
      } = error.response;
      const statusCode = parseInt(status);
      const errorMsg = (typeof data === 'string' ? data : get(data, 'message', 'error')).trim();
      routeToError({
        statusCode,
        errorMsg
      });
    }
  },

  methods: {
    async acceptInvitation() {
      if (this.storybookMock) {
        this.$emit('storybook-accept-invite-clicked');
        return;
      }

      this.acceptingInvitation = true;
      let response;

      try {
        response = await confirmInvitation(this.encodedKey);
      } catch (error) {
        response = error.response;
      }

      if (!response) {
        this.acceptingInvitation = false;
        return;
      }

      const {
        data,
        status
      } = response;
      const statusCode = parseInt(status);

      if (statusCode === 200) {
        const {
          redirect
        } = data;

        if (redirect === 'setPassword') {
          const queryParamString = this.searchString ? `${this.searchString}&type=setup` : '?type=setup';
          this.navigateToPath(`/register/resetpassword/${this.parsedKey.Email}/${this.encodedKey}${queryParamString}`);
          return;
        }

        if (redirect === 'createAccount') {
          this.navigateToPath(`/register/complete/${this.parsedKey.Email}/${this.encodedKey}${this.searchString}`);
          return;
        }

        this.navigateToPath(`/${this.searchString}`);
      } else {
        const errorMsg = (typeof data === 'string' ? data : get(data, 'message', 'error')).trim();
        routeToError({
          statusCode,
          errorMsg
        });
      }
    },

    navigateToPath(path) {
      return window.location.assign(path);
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', {
    scopedSlots: _vm._u([!_vm.isLoading ? {
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    } : null], null, true)
  }, [_vm.isLoading ? _c('pendo-loading-indicator', {
    attrs: {
      "size": "large"
    }
  }) : _c('pendo-card', {
    staticClass: "accept-invite-card",
    attrs: {
      "body-min-height": "0",
      "footer-min-height": "0"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('confirmation-icon')];
      },
      proxy: true
    }, {
      key: "body",
      fn: function () {
        return [_c('h3', {
          staticClass: "accept-invite-info-title"
        }, [_vm._v("\n                " + _vm._s(_vm.productNameTitleMessage) + "\n            ")]), _vm._v(" "), _c('h3', {
          staticClass: "accept-invite-info-title accept-invite-info-sub-name"
        }, [_vm._v("\n                " + _vm._s(_vm.subscriptionName) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.content.subtitle) + " "), _c('strong', [_vm._v(_vm._s(_vm.subscriptionName))]), _vm._v(".\n            ")])];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('pendo-button', {
          attrs: {
            "data-cy": "accept-invite-button",
            "type": "primary",
            "theme": "app",
            "block": "",
            "loading": _vm.acceptingInvitation,
            "label": _vm.content.button
          },
          on: {
            "click": _vm.acceptInvitation
          }
        })];
      },
      proxy: true
    }])
  })], 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-5e684b4c_0", {
    source: ".accept-invite-info-title[data-v-5e684b4c]{margin:0 13px 25px 0;font-size:22px;line-height:26px;font-weight:700}.accept-invite-logo[data-v-5e684b4c]{position:absolute;top:32px;left:32px;z-index:-1}.accept-invite-logo img[data-v-5e684b4c]{width:130px;height:30px}p[data-v-5e684b4c]{font-size:16px;line-height:26.25px}.accept-invite-card[data-v-5e684b4c]{width:400px;display:flex;flex-direction:column;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,.17)}.accept-invite-card[data-v-5e684b4c] .pendo-card__header{display:flex;justify-content:center;align-items:center;padding:10px;height:125px;border-bottom:none}.accept-invite-card[data-v-5e684b4c] .accept-invite-info-sub-name{color:#128297}.accept-invite-card[data-v-5e684b4c] .pendo-card__body{padding:10px 24px;text-align:center;border-bottom:none}.accept-invite-card[data-v-5e684b4c] .pendo-card__footer{overflow:hidden;padding:16px 24px;border-top:none}.accept-invite-card[data-v-5e684b4c] .pendo-page{left:0!important}@media only screen and (max-width:767px){.accept-invite-card[data-v-5e684b4c]{margin-top:25px}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$4 = "data-v-5e684b4c";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
const MIN_CHARS = 12;
const MAX_CHARS = 72;
var script$3 = {
  name: 'SetPasswordForm',
  components: {
    PendoForm,
    PendoFormItem,
    PendoIcon,
    PendoCheckbox,
    PendoPopover,
    PendoInputPassword
  },
  props: {
    resetPassword: {
      type: Boolean,
      default: true
    },
    isWhiteLabel: {
      type: Boolean,
      default: false
    },
    isNight: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      rules: {
        password: [{
          required: true,
          message: 'Password is required',
          trigger: ['blur', 'change']
        }, {
          validator: this.validatePasswordLength,
          trigger: ['blur', 'change']
        }],
        passwordConfirmation: [{
          required: true,
          message: 'Password confirmation is required',
          trigger: ['blur', 'change']
        }, {
          validator: this.validateConfirmPassword,
          trigger: ['blur', 'change']
        }],
        termsConditions: [{
          required: true,
          message: 'You must agree to the terms and conditions',
          trigger: ['change']
        }, {
          validator: this.validateTermsConditions,
          trigger: ['change']
        }]
      },
      model: {
        password: '',
        passwordConfirmation: '',
        termsConditions: false
      },
      callValidate: false,
      submitOnValid: false,
      showConfirmPassword: false,
      showPassword: false
    };
  },

  computed: {
    overMaxCharacters() {
      return this.model.password && this.model.password.length > MAX_CHARS;
    }

  },
  methods: {
    toggleVisibility(showPasswordFlag) {
      this[showPasswordFlag] = !this[showPasswordFlag];
    },

    validateForm() {
      let {
        submitOnValid = false
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.submitOnValid = submitOnValid;
      this.callValidate = true;
    },

    onValidForm() {
      this.$emit('valid', {
        model: this.model,
        submit: this.submitOnValid
      });
      this.callValidate = false;
    },

    onInvalidForm() {
      this.$emit('invalid', this.model);
      this.callValidate = false;
    },

    validateConfirmPassword(rule, val, cb) {
      if (val === this.model.password) {
        cb();
      } else {
        cb(new Error("Password doesn't match"));
      }
    },

    validatePasswordLength(rule, val, cb) {
      if (val.length < MIN_CHARS) {
        cb(new Error('Password must contain at least 12 characters'));
      } else if (val.length > MAX_CHARS) {
        cb(new Error("Password can't exceed 72 characters"));
      } else {
        cb();
      }
    },

    validateTermsConditions(rule, val, cb) {
      if (val || this.resetPassword) {
        cb();
      } else {
        cb(new Error('You must agree to the terms and conditions'));
      }
    },

    checkBoxToggle() {
      this.model.termsConditions = !this.model.termsConditions;
      this.validateForm();
    },

    onFocus() {
      this.$emit('on-focus');
    }

  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-form', {
    staticClass: "password-form",
    class: {
      'password-form-night': _vm.isNight
    },
    attrs: {
      "model": _vm.model,
      "call-validate": _vm.callValidate
    },
    on: {
      "formValidated": _vm.onValidForm,
      "invalidForm": _vm.onInvalidForm
    }
  }, [_c('pendo-form-item', {
    attrs: {
      "id": "password",
      "rules": _vm.rules.password,
      "prop": "password",
      "name": "password",
      "label": "Password"
    }
  }, [_c('pendo-input-password', {
    attrs: {
      "id": "password",
      "name": "password",
      "placeholder": "Enter password",
      "show-password-strength": !_vm.overMaxCharacters,
      "autocomplete": "new-password"
    },
    on: {
      "focus": _vm.onFocus,
      "input": _vm.validateForm
    },
    model: {
      value: _vm.model.password,
      callback: function ($$v) {
        _vm.$set(_vm.model, "password", $$v);
      },
      expression: "model.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "password-tooltip"
  }, [_vm._v("\n        What makes a password strong?\n        "), _c('pendo-popover', {
    staticClass: "password-popover",
    attrs: {
      "arrow": ""
    },
    scopedSlots: _vm._u([{
      key: "popover",
      fn: function () {
        return [_c('div', {
          staticClass: "password-popover--content"
        }, [_c('p', {
          staticClass: "password-popover--header"
        }, [_vm._v("\n                        What makes a password strong?\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        A secure password is at least 12 characters long and hard to guess. When choosing a more\n                        secure password that will be easier to remember, consider creating a story.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        For example, TheQuickBr0wnF0xJump$D0wn is more secure than P@$$w0rd123. (Just don't use\n                        these examples as your password!)\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Most importantly, never re-use passwords! You should always use a unique password for every\n                        site.\n                    ")])])];
      },
      proxy: true
    }])
  }, [_c('pendo-icon', {
    staticClass: "info-icon",
    attrs: {
      "type": "info",
      "size": "16"
    }
  })], 1)], 1), _vm._v(" "), _c('pendo-form-item', {
    attrs: {
      "id": "passwordConfirmation",
      "rules": _vm.rules.passwordConfirmation,
      "prop": "passwordConfirmation",
      "name": "passwordConfirmation",
      "label": "Confirm password"
    }
  }, [_c('pendo-input-password', {
    attrs: {
      "id": "passwordConfirmation",
      "name": "passwordConfirmation",
      "placeholder": "Confirm password",
      "autocomplete": "off"
    },
    on: {
      "focus": _vm.onFocus,
      "input": _vm.validateForm
    },
    model: {
      value: _vm.model.passwordConfirmation,
      callback: function ($$v) {
        _vm.$set(_vm.model, "passwordConfirmation", $$v);
      },
      expression: "model.passwordConfirmation"
    }
  })], 1), _vm._v(" "), !_vm.resetPassword ? _c('pendo-form-item', {
    attrs: {
      "id": "termsConditions",
      "rules": _vm.rules.termsConditions,
      "prop": "termsConditions",
      "name": "termsConditions",
      "label": ""
    }
  }, [_c('div', {
    staticClass: "terms",
    attrs: {
      "data-cy": "terms-checkbox"
    }
  }, [_c('pendo-checkbox', {
    attrs: {
      "value": _vm.model.termsConditions,
      "rule": _vm.rules.termsConditions
    },
    on: {
      "change": _vm.checkBoxToggle
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "register__terms-checkbox"
  }, [_vm._v("\n                I agree to the\n                "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.pendo.io/legal/software-services-agreement/"
    }
  }, [!_vm.isWhiteLabel ? _c('span', [_vm._v("Pendo ")]) : _vm._e(), _vm._v("Software Services Agreement\n                ")]), _vm._v("\n                and the\n                "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.pendo.io/legal/privacy-policy/"
    }
  }, [_vm._v("\n                    Privacy Policy.\n                ")])])], 1)]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-7cfcd04a_0", {
    source: ".password-form[data-v-7cfcd04a]{text-align:left}.password-form[data-v-7cfcd04a] .pendo-input__field{background:0 0!important}.password-form .pendo-form-item[data-v-7cfcd04a]:last-of-type{margin-bottom:0}.password-tooltip[data-v-7cfcd04a]{font-size:14px;margin-bottom:16px;color:#6a6c75}.password-popover[data-v-7cfcd04a]{display:inline-block;vertical-align:middle;color:#6a6c75}.password-popover--header[data-v-7cfcd04a]{font-weight:700;margin-top:0}.password-popover--content[data-v-7cfcd04a]{font-size:14px;color:#2a2c35;line-height:1.4;width:340px}.terms[data-v-7cfcd04a]{display:flex;align-items:baseline;margin-top:12px}.terms[data-v-7cfcd04a]:not(:last-of-type){margin-bottom:8px}.terms[data-v-7cfcd04a] .pendo-checkbox{padding-right:8px;display:block}.password-form-night[data-v-7cfcd04a]{text-align:left}.password-form-night .info-icon[data-v-7cfcd04a],.password-form-night .password-tooltip[data-v-7cfcd04a],.password-form-night[data-v-7cfcd04a]  .pendo-input-password__visibility-toggle,.password-form-night[data-v-7cfcd04a] .pendo-form-item__label{color:#f4f4f7}.password-form-night[data-v-7cfcd04a] .pendo-input__field:hover{border-color:#fff}.password-form-night[data-v-7cfcd04a]  .pendo-checkbox,.password-form-night[data-v-7cfcd04a]  input{color:#fff}.password-form-night[data-v-7cfcd04a]  .pendo-input-password__password-strength .password-strength__meter-divider{background-color:#2a2c35}.password-form-night .register__terms-checkbox>a[data-v-7cfcd04a]{color:#45a0b8}.password-form-night .register__terms-checkbox>a[data-v-7cfcd04a]:hover{color:#128297}.password-form-night[data-v-7cfcd04a] .pendo-form-item.is-required .pendo-form-item__label:after,.password-form-night[data-v-7cfcd04a] .pendo-form-item__error,.password-form-night[data-v-7cfcd04a] .pendo-input-password__password-strength[data-strength=\"0\"] .password-strength__label,.password-form-night[data-v-7cfcd04a] .pendo-input-password__password-strength[data-strength=\"1\"] .password-strength__label{color:#ff7f74}.password-form-night[data-v-7cfcd04a] .pendo-input-password__password-strength[data-strength=\"0\"] .password-strength__fill,.password-form-night[data-v-7cfcd04a] .pendo-input-password__password-strength[data-strength=\"0\"] .password-strength__meter,.password-form-night[data-v-7cfcd04a] .pendo-input-password__password-strength[data-strength=\"1\"] .password-strength__fill,.password-form-night[data-v-7cfcd04a] .pendo-input-password__password-strength[data-strength=\"1\"] .password-strength__meter{background-color:#ff7f74}.password-form-night[data-v-7cfcd04a] .pendo-form-item.is-error .pendo-input__field{border-color:#ff7f74}[data-v-7cfcd04a] #password input::-ms-reveal,[data-v-7cfcd04a] #passwordConfirmation input::-ms-reveal{display:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$3 = "data-v-7cfcd04a";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var DecodeJzb = createCommonjsModule(function (module, exports) {
!function(t,e){e(exports);}(commonjsGlobal,function(t){for(var e=function(t){var e=d(t),a=e[0],n=e[1];return 3*(a+n)/4-n},a=function(t){var e,a,n=d(t),i=n[0],o=n[1],l=new s(function(t,e,a){return 3*(e+a)/4-a}(0,i,o)),h=0,_=o>0?i-4:i;for(a=0;a<_;a+=4)e=r[t.charCodeAt(a)]<<18|r[t.charCodeAt(a+1)]<<12|r[t.charCodeAt(a+2)]<<6|r[t.charCodeAt(a+3)],l[h++]=e>>16&255,l[h++]=e>>8&255,l[h++]=255&e;2===o&&(e=r[t.charCodeAt(a)]<<2|r[t.charCodeAt(a+1)]>>4,l[h++]=255&e);1===o&&(e=r[t.charCodeAt(a)]<<10|r[t.charCodeAt(a+1)]<<4|r[t.charCodeAt(a+2)]>>2,l[h++]=e>>8&255,l[h++]=255&e);return l},n=function(t){for(var e,a=t.length,n=a%3,r=[],s=0,o=a-n;s<o;s+=16383)r.push(_(t,s,s+16383>o?o:s+16383));1===n?(e=t[a-1],r.push(i[e>>2]+i[e<<4&63]+"==")):2===n&&(e=(t[a-2]<<8)+t[a-1],r.push(i[e>>10]+i[e>>4&63]+i[e<<2&63]+"="));return r.join("")},i=[],r=[],s="undefined"!=typeof Uint8Array?Uint8Array:Array,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",l=0,h=o.length;l<h;++l)i[l]=o[l],r[o.charCodeAt(l)]=l;function d(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var a=t.indexOf("=");return -1===a&&(a=e),[a,a===e?0:4-a%4]}function _(t,e,a){for(var n,r,s=[],o=e;o<a;o+=3)n=(t[o]<<16&16711680)+(t[o+1]<<8&65280)+(255&t[o+2]),s.push(i[(r=n)>>18&63]+i[r>>12&63]+i[r>>6&63]+i[63&r]);return s.join("")}r["-".charCodeAt(0)]=62,r["_".charCodeAt(0)]=63;var f={byteLength:e,toByteArray:a,fromByteArray:n};function c(t){let e=t.length;for(;--e>=0;)t[e]=0;}const u=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),w=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),b=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),g=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),p=new Array(576);c(p);const m=new Array(60);c(m);const k=new Array(512);c(k);const v=new Array(256);c(v);const y=new Array(29);c(y);const x=new Array(30);function z(t,e,a,n,i){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=i,this.has_stree=t&&t.length;}let A,E,R;function Z(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e;}c(x);const S=t=>t<256?k[t]:k[256+(t>>>7)],U=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255;},D=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,U(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a);},O=(t,e,a)=>{D(t,a[2*e],a[2*e+1]);},T=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1;}while(--e>0);return a>>>1},C=(t,e,a)=>{const n=new Array(16);let i,r,s=0;for(i=1;i<=15;i++)n[i]=s=s+a[i-1]<<1;for(r=0;r<=e;r++){let e=t[2*r+1];0!==e&&(t[2*r]=T(n[e]++,e));}},N=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0;},B=t=>{t.bi_valid>8?U(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0;},L=(t,e,a,n)=>{const i=2*e,r=2*a;return t[i]<t[r]||t[i]===t[r]&&n[e]<=n[a]},I=(t,e,a)=>{const n=t.heap[a];let i=a<<1;for(;i<=t.heap_len&&(i<t.heap_len&&L(e,t.heap[i+1],t.heap[i],t.depth)&&i++,!L(e,n,t.heap[i],t.depth));)t.heap[a]=t.heap[i],a=i,i<<=1;t.heap[a]=n;},F=(t,e,a)=>{let n,i,r,s,o=0;if(0!==t.last_lit)do{n=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===n?O(t,i,e):(r=v[i],O(t,r+256+1,e),0!==(s=u[r])&&(i-=y[r],D(t,i,s)),r=S(--n),O(t,r,a),0!==(s=w[r])&&(n-=x[r],D(t,n,s)));}while(o<t.last_lit);O(t,256,e);},M=(t,e)=>{const a=e.dyn_tree,n=e.stat_desc.static_tree,i=e.stat_desc.has_stree,r=e.stat_desc.elems;let s,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,s=0;s<r;s++)0!==a[2*s]?(t.heap[++t.heap_len]=h=s,t.depth[s]=0):a[2*s+1]=0;for(;t.heap_len<2;)a[2*(l=t.heap[++t.heap_len]=h<2?++h:0)]=1,t.depth[l]=0,t.opt_len--,i&&(t.static_len-=n[2*l+1]);for(e.max_code=h,s=t.heap_len>>1;s>=1;s--)I(t,a,s);l=r;do{s=t.heap[1],t.heap[1]=t.heap[t.heap_len--],I(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=s,t.heap[--t.heap_max]=o,a[2*l]=a[2*s]+a[2*o],t.depth[l]=(t.depth[s]>=t.depth[o]?t.depth[s]:t.depth[o])+1,a[2*s+1]=a[2*o+1]=l,t.heap[1]=l++,I(t,a,1);}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,n=e.max_code,i=e.stat_desc.static_tree,r=e.stat_desc.has_stree,s=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)(f=a[2*a[2*(d=t.heap[h])+1]+1]+1)>l&&(f=l,w++),a[2*d+1]=f,d>n||(t.bl_count[f]++,c=0,d>=o&&(c=s[d-o]),u=a[2*d],t.opt_len+=u*(f+c),r&&(t.static_len+=u*(i[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2;}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)(_=t.heap[--h])>n||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--);}})(t,e),C(a,h,t.bl_count);},H=(t,e,a)=>{let n,i,r=-1,s=e[1],o=0,l=7,h=4;for(0===s&&(l=138,h=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)i=s,s=e[2*(n+1)+1],++o<l&&i===s||(o<h?t.bl_tree[2*i]+=o:0!==i?(i!==r&&t.bl_tree[2*i]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,r=i,0===s?(l=138,h=3):i===s?(l=6,h=3):(l=7,h=4));},j=(t,e,a)=>{let n,i,r=-1,s=e[1],o=0,l=7,h=4;for(0===s&&(l=138,h=3),n=0;n<=a;n++)if(i=s,s=e[2*(n+1)+1],!(++o<l&&i===s)){if(o<h)do{O(t,i,t.bl_tree);}while(0!=--o);else 0!==i?(i!==r&&(O(t,i,t.bl_tree),o--),O(t,16,t.bl_tree),D(t,o-3,2)):o<=10?(O(t,17,t.bl_tree),D(t,o-3,3)):(O(t,18,t.bl_tree),D(t,o-11,7));o=0,r=i,0===s?(l=138,h=3):i===s?(l=6,h=3):(l=7,h=4);}};let K=!1;const P=(t,e,a,n)=>{D(t,0+(n?1:0),3),((t,e,a,n)=>{B(t),n&&(U(t,a),U(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a;})(t,e,a,!0);};var J={_tr_init:t=>{K||((()=>{let t,e,a,n,i;const r=new Array(16);for(a=0,n=0;n<28;n++)for(y[n]=a,t=0;t<1<<u[n];t++)v[a++]=n;for(v[a-1]=n,i=0,n=0;n<16;n++)for(x[n]=i,t=0;t<1<<w[n];t++)k[i++]=n;for(i>>=7;n<30;n++)for(x[n]=i<<7,t=0;t<1<<w[n]-7;t++)k[256+i++]=n;for(e=0;e<=15;e++)r[e]=0;for(t=0;t<=143;)p[2*t+1]=8,t++,r[8]++;for(;t<=255;)p[2*t+1]=9,t++,r[9]++;for(;t<=279;)p[2*t+1]=7,t++,r[7]++;for(;t<=287;)p[2*t+1]=8,t++,r[8]++;for(C(p,287,r),t=0;t<30;t++)m[2*t+1]=5,m[2*t]=T(t,5);A=new z(p,u,257,286,15),E=new z(m,w,0,30,15),R=new z(new Array(0),b,0,19,7);})(),K=!0),t.l_desc=new Z(t.dyn_ltree,A),t.d_desc=new Z(t.dyn_dtree,E),t.bl_desc=new Z(t.bl_tree,R),t.bi_buf=0,t.bi_valid=0,N(t);},_tr_stored_block:P,_tr_flush_block:(t,e,a,n)=>{let i,r,s=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),M(t,t.l_desc),M(t,t.d_desc),s=(t=>{let e;for(H(t,t.dyn_ltree,t.l_desc.max_code),H(t,t.dyn_dtree,t.d_desc.max_code),M(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*g[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),i=t.opt_len+3+7>>>3,(r=t.static_len+3+7>>>3)<=i&&(i=r)):i=r=a+5,a+4<=i&&-1!==e?P(t,e,a,n):4===t.strategy||r===i?(D(t,2+(n?1:0),3),F(t,p,m)):(D(t,4+(n?1:0),3),((t,e,a,n)=>{let i;for(D(t,e-257,5),D(t,a-1,5),D(t,n-4,4),i=0;i<n;i++)D(t,t.bl_tree[2*g[i]+1],3);j(t,t.dyn_ltree,e-1),j(t,t.dyn_dtree,a-1);})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,s+1),F(t,t.dyn_ltree,t.dyn_dtree)),N(t),n&&B(t);},_tr_tally:(t,e,a)=>(t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&a,t.last_lit++,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(v[a]+256+1)]++,t.dyn_dtree[2*S(e)]++),t.last_lit===t.lit_bufsize-1),_tr_align:t=>{D(t,2,3),O(t,256,p),(t=>{16===t.bi_valid?(U(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8);})(t);}};var Y=(t,e,a,n)=>{let i=65535&t|0,r=t>>>16&65535|0,s=0;for(;0!==a;){a-=s=a>2e3?2e3:a;do{r=r+(i=i+e[n++]|0)|0;}while(--s);i%=65521,r%=65521;}return i|r<<16|0};const G=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t;}return e})());var W=(t,e,a,n)=>{const i=G,r=n+a;t^=-1;for(let a=n;a<r;a++)t=t>>>8^i[255&(t^e[a])];return -1^t},X={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},q={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:Q,_tr_stored_block:V,_tr_flush_block:$,_tr_tally:tt,_tr_align:et}=J,{Z_NO_FLUSH:at,Z_PARTIAL_FLUSH:nt,Z_FULL_FLUSH:it,Z_FINISH:rt,Z_BLOCK:st,Z_OK:ot,Z_STREAM_END:lt,Z_STREAM_ERROR:ht,Z_DATA_ERROR:dt,Z_BUF_ERROR:_t,Z_DEFAULT_COMPRESSION:ft,Z_FILTERED:ct,Z_HUFFMAN_ONLY:ut,Z_RLE:wt,Z_FIXED:bt,Z_DEFAULT_STRATEGY:gt,Z_UNKNOWN:pt,Z_DEFLATED:mt}=q,kt=286,vt=30,yt=19,xt=2*kt+1,zt=15,At=(t,e)=>(t.msg=X[e],e),Et=t=>(t<<1)-(t>4?9:0),Rt=t=>{let e=t.length;for(;--e>=0;)t[e]=0;};let Zt=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const St=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0));},Ut=(t,e)=>{$(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,St(t.strm);},Dt=(t,e)=>{t.pending_buf[t.pending++]=e;},Ot=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e;},Tt=(t,e,a,n)=>{let i=t.avail_in;return i>n&&(i=n),0===i?0:(t.avail_in-=i,e.set(t.input.subarray(t.next_in,t.next_in+i),a),1===t.state.wrap?t.adler=Y(t.adler,e,i,a):2===t.state.wrap&&(t.adler=W(t.adler,e,i,a)),t.next_in+=i,t.total_in+=i,i)},Ct=(t,e)=>{let a,n,i=t.max_chain_length,r=t.strstart,s=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[r+s-1],u=h[r+s];t.prev_length>=t.good_match&&(i>>=2),o>t.lookahead&&(o=t.lookahead);do{if(h[(a=e)+s]===u&&h[a+s-1]===c&&h[a]===h[r]&&h[++a]===h[r+1]){r+=2,a++;do{}while(h[++r]===h[++a]&&h[++r]===h[++a]&&h[++r]===h[++a]&&h[++r]===h[++a]&&h[++r]===h[++a]&&h[++r]===h[++a]&&h[++r]===h[++a]&&h[++r]===h[++a]&&r<f);if(n=258-(f-r),r=f-258,n>s){if(t.match_start=e,s=n,n>=o)break;c=h[r+s-1],u=h[r+s];}}}while((e=_[e&d])>l&&0!=--i);return s<=t.lookahead?s:t.lookahead},Nt=t=>{const e=t.w_size;let a,n,i,r,s;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)){t.window.set(t.window.subarray(e,e+e),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,a=n=t.hash_size;do{i=t.head[--a],t.head[a]=i>=e?i-e:0;}while(--n);a=n=e;do{i=t.prev[--a],t.prev[a]=i>=e?i-e:0;}while(--n);r+=e;}if(0===t.strm.avail_in)break;if(n=Tt(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=n,t.lookahead+t.insert>=3)for(s=t.strstart-t.insert,t.ins_h=t.window[s],t.ins_h=Zt(t,t.ins_h,t.window[s+1]);t.insert&&(t.ins_h=Zt(t,t.ins_h,t.window[s+3-1]),t.prev[s&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=s,s++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},Bt=(t,e)=>{let a,n;for(;;){if(t.lookahead<262){if(Nt(t),t.lookahead<262&&e===at)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=Zt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=Ct(t,a)),t.match_length>=3)if(n=tt(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=Zt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart;}while(0!=--t.match_length);t.strstart++;}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=Zt(t,t.ins_h,t.window[t.strstart+1]);else n=tt(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===rt?(Ut(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ut(t,!1),0===t.strm.avail_out)?1:2},Lt=(t,e)=>{let a,n,i;for(;;){if(t.lookahead<262){if(Nt(t),t.lookahead<262&&e===at)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=Zt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=Ct(t,a),t.match_length<=5&&(t.strategy===ct||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){i=t.strstart+t.lookahead-3,n=tt(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=i&&(t.ins_h=Zt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart);}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=tt(t,0,t.window[t.strstart-1]))&&Ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--;}return t.match_available&&(n=tt(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===rt?(Ut(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ut(t,!1),0===t.strm.avail_out)?1:2};function It(t,e,a,n,i){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=i;}const Ft=[new It(0,0,0,0,(t,e)=>{let a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Nt(t),0===t.lookahead&&e===at)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;const n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Ut(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-262&&(Ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===rt?(Ut(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Ut(t,!1),t.strm.avail_out),1)}),new It(4,4,8,4,Bt),new It(4,5,16,8,Bt),new It(4,6,32,32,Bt),new It(4,4,16,16,Lt),new It(8,16,32,32,Lt),new It(8,16,128,128,Lt),new It(8,32,128,256,Lt),new It(32,128,258,1024,Lt),new It(32,258,258,4096,Lt)];function Mt(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=mt,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(2*xt),this.dyn_dtree=new Uint16Array(2*(2*vt+1)),this.bl_tree=new Uint16Array(2*(2*yt+1)),Rt(this.dyn_ltree),Rt(this.dyn_dtree),Rt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(zt+1),this.heap=new Uint16Array(2*kt+1),Rt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(2*kt+1),Rt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0;}const Ht=t=>{if(!t||!t.state)return At(t,ht);t.total_in=t.total_out=0,t.data_type=pt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=at,Q(e),ot},jt=t=>{const e=Ht(t);return e===ot&&(t=>{t.window_size=2*t.w_size,Rt(t.head),t.max_lazy_match=Ft[t.level].max_lazy,t.good_match=Ft[t.level].good_length,t.nice_match=Ft[t.level].nice_length,t.max_chain_length=Ft[t.level].max_chain,t.strstart=0,t.block_start=0,t.lookahead=0,t.insert=0,t.match_length=t.prev_length=2,t.match_available=0,t.ins_h=0;})(t.state),e},Kt=(t,e,a,n,i,r)=>{if(!t)return ht;let s=1;if(e===ft&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),i<1||i>9||a!==mt||n<8||n>15||e<0||e>9||r<0||r>bt)return At(t,ht);8===n&&(n=9);const o=new Mt;return t.state=o,o.strm=t,o.wrap=s,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=e,o.strategy=r,o.method=a,jt(t)};var Pt={deflateInit:(t,e)=>Kt(t,e,mt,15,8,gt),deflateInit2:Kt,deflateReset:jt,deflateResetKeep:Ht,deflateSetHeader:(t,e)=>t&&t.state?2!==t.state.wrap?ht:(t.state.gzhead=e,ot):ht,deflate:(t,e)=>{let a,n;if(!t||!t.state||e>st||e<0)return t?At(t,ht):ht;const i=t.state;if(!t.output||!t.input&&0!==t.avail_in||666===i.status&&e!==rt)return At(t,0===t.avail_out?_t:ht);i.strm=t;const r=i.last_flush;if(i.last_flush=e,42===i.status)if(2===i.wrap)t.adler=0,Dt(i,31),Dt(i,139),Dt(i,8),i.gzhead?(Dt(i,(i.gzhead.text?1:0)+(i.gzhead.hcrc?2:0)+(i.gzhead.extra?4:0)+(i.gzhead.name?8:0)+(i.gzhead.comment?16:0)),Dt(i,255&i.gzhead.time),Dt(i,i.gzhead.time>>8&255),Dt(i,i.gzhead.time>>16&255),Dt(i,i.gzhead.time>>24&255),Dt(i,9===i.level?2:i.strategy>=ut||i.level<2?4:0),Dt(i,255&i.gzhead.os),i.gzhead.extra&&i.gzhead.extra.length&&(Dt(i,255&i.gzhead.extra.length),Dt(i,i.gzhead.extra.length>>8&255)),i.gzhead.hcrc&&(t.adler=W(t.adler,i.pending_buf,i.pending,0)),i.gzindex=0,i.status=69):(Dt(i,0),Dt(i,0),Dt(i,0),Dt(i,0),Dt(i,0),Dt(i,9===i.level?2:i.strategy>=ut||i.level<2?4:0),Dt(i,3),i.status=113);else {let e=mt+(i.w_bits-8<<4)<<8;e|=(i.strategy>=ut||i.level<2?0:i.level<6?1:6===i.level?2:3)<<6,0!==i.strstart&&(e|=32),e+=31-e%31,i.status=113,Ot(i,e),0!==i.strstart&&(Ot(i,t.adler>>>16),Ot(i,65535&t.adler)),t.adler=1;}if(69===i.status)if(i.gzhead.extra){for(a=i.pending;i.gzindex<(65535&i.gzhead.extra.length)&&(i.pending!==i.pending_buf_size||(i.gzhead.hcrc&&i.pending>a&&(t.adler=W(t.adler,i.pending_buf,i.pending-a,a)),St(t),a=i.pending,i.pending!==i.pending_buf_size));)Dt(i,255&i.gzhead.extra[i.gzindex]),i.gzindex++;i.gzhead.hcrc&&i.pending>a&&(t.adler=W(t.adler,i.pending_buf,i.pending-a,a)),i.gzindex===i.gzhead.extra.length&&(i.gzindex=0,i.status=73);}else i.status=73;if(73===i.status)if(i.gzhead.name){a=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>a&&(t.adler=W(t.adler,i.pending_buf,i.pending-a,a)),St(t),a=i.pending,i.pending===i.pending_buf_size)){n=1;break}n=i.gzindex<i.gzhead.name.length?255&i.gzhead.name.charCodeAt(i.gzindex++):0,Dt(i,n);}while(0!==n);i.gzhead.hcrc&&i.pending>a&&(t.adler=W(t.adler,i.pending_buf,i.pending-a,a)),0===n&&(i.gzindex=0,i.status=91);}else i.status=91;if(91===i.status)if(i.gzhead.comment){a=i.pending;do{if(i.pending===i.pending_buf_size&&(i.gzhead.hcrc&&i.pending>a&&(t.adler=W(t.adler,i.pending_buf,i.pending-a,a)),St(t),a=i.pending,i.pending===i.pending_buf_size)){n=1;break}n=i.gzindex<i.gzhead.comment.length?255&i.gzhead.comment.charCodeAt(i.gzindex++):0,Dt(i,n);}while(0!==n);i.gzhead.hcrc&&i.pending>a&&(t.adler=W(t.adler,i.pending_buf,i.pending-a,a)),0===n&&(i.status=103);}else i.status=103;if(103===i.status&&(i.gzhead.hcrc?(i.pending+2>i.pending_buf_size&&St(t),i.pending+2<=i.pending_buf_size&&(Dt(i,255&t.adler),Dt(i,t.adler>>8&255),t.adler=0,i.status=113)):i.status=113),0!==i.pending){if(St(t),0===t.avail_out)return i.last_flush=-1,ot}else if(0===t.avail_in&&Et(e)<=Et(r)&&e!==rt)return At(t,_t);if(666===i.status&&0!==t.avail_in)return At(t,_t);if(0!==t.avail_in||0!==i.lookahead||e!==at&&666!==i.status){let a=i.strategy===ut?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(Nt(t),0===t.lookahead)){if(e===at)return 1;break}if(t.match_length=0,a=tt(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===rt?(Ut(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ut(t,!1),0===t.strm.avail_out)?1:2})(i,e):i.strategy===wt?((t,e)=>{let a,n,i,r;const s=t.window;for(;;){if(t.lookahead<=258){if(Nt(t),t.lookahead<=258&&e===at)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[i=t.strstart-1])===s[++i]&&n===s[++i]&&n===s[++i]){r=t.strstart+258;do{}while(n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&n===s[++i]&&i<r);t.match_length=258-(r-i),t.match_length>t.lookahead&&(t.match_length=t.lookahead);}if(t.match_length>=3?(a=tt(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=tt(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===rt?(Ut(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Ut(t,!1),0===t.strm.avail_out)?1:2})(i,e):Ft[i.level].func(i,e);if(3!==a&&4!==a||(i.status=666),1===a||3===a)return 0===t.avail_out&&(i.last_flush=-1),ot;if(2===a&&(e===nt?et(i):e!==st&&(V(i,0,0,!1),e===it&&(Rt(i.head),0===i.lookahead&&(i.strstart=0,i.block_start=0,i.insert=0))),St(t),0===t.avail_out))return i.last_flush=-1,ot}return e!==rt?ot:i.wrap<=0?lt:(2===i.wrap?(Dt(i,255&t.adler),Dt(i,t.adler>>8&255),Dt(i,t.adler>>16&255),Dt(i,t.adler>>24&255),Dt(i,255&t.total_in),Dt(i,t.total_in>>8&255),Dt(i,t.total_in>>16&255),Dt(i,t.total_in>>24&255)):(Ot(i,t.adler>>>16),Ot(i,65535&t.adler)),St(t),i.wrap>0&&(i.wrap=-i.wrap),0!==i.pending?ot:lt)},deflateEnd:t=>{if(!t||!t.state)return ht;const e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&103!==e&&113!==e&&666!==e?At(t,ht):(t.state=null,113===e?At(t,dt):ot)},deflateSetDictionary:(t,e)=>{let a=e.length;if(!t||!t.state)return ht;const n=t.state,i=n.wrap;if(2===i||1===i&&42!==n.status||n.lookahead)return ht;if(1===i&&(t.adler=Y(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===i&&(Rt(n.head),n.strstart=0,n.block_start=0,n.insert=0);let t=new Uint8Array(n.w_size);t.set(e.subarray(a-n.w_size,a),0),e=t,a=n.w_size;}const r=t.avail_in,s=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Nt(n);n.lookahead>=3;){let t=n.strstart,e=n.lookahead-2;do{n.ins_h=Zt(n,n.ins_h,n.window[t+3-1]),n.prev[t&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=t,t++;}while(--e);n.strstart=t,n.lookahead=2,Nt(n);}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=s,t.input=o,t.avail_in=r,n.wrap=i,ot},deflateInfo:"pako deflate (from Nodeca project)"};const Jt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Yt={assign:function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Jt(a,e)&&(t[e]=a[e]);}}return t},flattenChunks:t=>{let e=0;for(let a=0,n=t.length;a<n;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,n=0,i=t.length;e<i;e++){let i=t[e];a.set(i,n),n+=i.length;}return a}};let Gt=!0;try{String.fromCharCode.apply(null,new Uint8Array(1));}catch(t){Gt=!1;}const Wt=new Uint8Array(256);for(let t=0;t<256;t++)Wt[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Wt[254]=Wt[254]=1;var Xt={string2buf:t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return (new TextEncoder).encode(t);let e,a,n,i,r,s=t.length,o=0;for(i=0;i<s;i++)55296==(64512&(a=t.charCodeAt(i)))&&i+1<s&&56320==(64512&(n=t.charCodeAt(i+1)))&&(a=65536+(a-55296<<10)+(n-56320),i++),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),r=0,i=0;r<o;i++)55296==(64512&(a=t.charCodeAt(i)))&&i+1<s&&56320==(64512&(n=t.charCodeAt(i+1)))&&(a=65536+(a-55296<<10)+(n-56320),i++),a<128?e[r++]=a:a<2048?(e[r++]=192|a>>>6,e[r++]=128|63&a):a<65536?(e[r++]=224|a>>>12,e[r++]=128|a>>>6&63,e[r++]=128|63&a):(e[r++]=240|a>>>18,e[r++]=128|a>>>12&63,e[r++]=128|a>>>6&63,e[r++]=128|63&a);return e},buf2string:(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return (new TextDecoder).decode(t.subarray(0,e));let n,i;const r=new Array(2*a);for(i=0,n=0;n<a;){let e=t[n++];if(e<128){r[i++]=e;continue}let s=Wt[e];if(s>4)r[i++]=65533,n+=s-1;else {for(e&=2===s?31:3===s?15:7;s>1&&n<a;)e=e<<6|63&t[n++],s--;s>1?r[i++]=65533:e<65536?r[i++]=e:(e-=65536,r[i++]=55296|e>>10&1023,r[i++]=56320|1023&e);}}return ((t,e)=>{if(e<65534&&t.subarray&&Gt)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let n=0;n<e;n++)a+=String.fromCharCode(t[n]);return a})(r,i)},utf8border:(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0?e:0===a?e:a+Wt[t[a]]>e?a:e}};var qt=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0;};const Qt=Object.prototype.toString,{Z_NO_FLUSH:Vt,Z_SYNC_FLUSH:$t,Z_FULL_FLUSH:te,Z_FINISH:ee,Z_OK:ae,Z_STREAM_END:ne,Z_DEFAULT_COMPRESSION:ie,Z_DEFAULT_STRATEGY:re,Z_DEFLATED:se}=q;function oe(t){this.options=Yt.assign({level:ie,method:se,chunkSize:16384,windowBits:15,memLevel:8,strategy:re},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new qt,this.strm.avail_out=0;let a=Pt.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==ae)throw new Error(X[a]);if(e.header&&Pt.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Xt.string2buf(e.dictionary):"[object ArrayBuffer]"===Qt.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,(a=Pt.deflateSetDictionary(this.strm,t))!==ae)throw new Error(X[a]);this._dict_set=!0;}}function le(t,e){const a=new oe(e);if(a.push(t,!0),a.err)throw a.msg||X[a.err];return a.result}oe.prototype.push=function(t,e){const a=this.strm,n=this.options.chunkSize;let i,r;if(this.ended)return !1;for(r=e===~~e?e:!0===e?ee:Vt,"string"==typeof t?a.input=Xt.string2buf(t):"[object ArrayBuffer]"===Qt.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(n),a.next_out=0,a.avail_out=n),(r===$t||r===te)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else {if((i=Pt.deflate(a,r))===ne)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),i=Pt.deflateEnd(this.strm),this.onEnd(i),this.ended=!0,i===ae;if(0!==a.avail_out){if(r>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output);}return !0},oe.prototype.onData=function(t){this.chunks.push(t);},oe.prototype.onEnd=function(t){t===ae&&(this.result=Yt.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg;};var he={Deflate:oe,deflate:le,deflateRaw:function(t,e){return (e=e||{}).raw=!0,le(t,e)},gzip:function(t,e){return (e=e||{}).gzip=!0,le(t,e)},constants:q};var de=function(t,e){let a,n,i,r,s,o,l,h,d,_,f,c,u,w,b,g,p,m,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,n=a+(t.avail_in-5),i=t.next_out,A=t.output,r=i-(e-t.avail_out),s=i+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,b=(1<<E.lenbits)-1,g=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),p=u[f&b];e:for(;;){if(f>>>=m=p>>>24,c-=m,0===(m=p>>>16&255))A[i++]=65535&p;else {if(!(16&m)){if(0==(64&m)){p=u[(65535&p)+(f&(1<<m)-1)];continue e}if(32&m){E.mode=12;break t}t.msg="invalid literal/length code",E.mode=30;break t}k=65535&p,(m&=15)&&(c<m&&(f+=z[a++]<<c,c+=8),k+=f&(1<<m)-1,f>>>=m,c-=m),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),p=w[f&g];a:for(;;){if(f>>>=m=p>>>24,c-=m,!(16&(m=p>>>16&255))){if(0==(64&m)){p=w[(65535&p)+(f&(1<<m)-1)];continue a}t.msg="invalid distance code",E.mode=30;break t}if(v=65535&p,c<(m&=15)&&(f+=z[a++]<<c,(c+=8)<m&&(f+=z[a++]<<c,c+=8)),(v+=f&(1<<m)-1)>o){t.msg="invalid distance too far back",E.mode=30;break t}if(f>>>=m,c-=m,v>(m=i-r)){if((m=v-m)>h&&E.sane){t.msg="invalid distance too far back",E.mode=30;break t}if(y=0,x=_,0===d){if(y+=l-m,m<k){k-=m;do{A[i++]=_[y++];}while(--m);y=i-v,x=A;}}else if(d<m){if(y+=l+d-m,(m-=d)<k){k-=m;do{A[i++]=_[y++];}while(--m);if(y=0,d<k){k-=m=d;do{A[i++]=_[y++];}while(--m);y=i-v,x=A;}}}else if(y+=d-m,m<k){k-=m;do{A[i++]=_[y++];}while(--m);y=i-v,x=A;}for(;k>2;)A[i++]=x[y++],A[i++]=x[y++],A[i++]=x[y++],k-=3;k&&(A[i++]=x[y++],k>1&&(A[i++]=x[y++]));}else {y=i-v;do{A[i++]=A[y++],A[i++]=A[y++],A[i++]=A[y++],k-=3;}while(k>2);k&&(A[i++]=A[y++],k>1&&(A[i++]=A[y++]));}break}}break}}while(a<n&&i<s);a-=k=c>>3,f&=(1<<(c-=k<<3))-1,t.next_in=a,t.next_out=i,t.avail_in=a<n?n-a+5:5-(a-n),t.avail_out=i<s?s-i+257:257-(i-s),E.hold=f,E.bits=c;};const _e=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),fe=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ce=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ue=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var we=(t,e,a,n,i,r,s,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,b=0,g=0,p=0,m=0,k=0,v=0,y=0,x=0,z=0,A=null,E=0;const R=new Uint16Array(16),Z=new Uint16Array(16);let S,U,D,O=null,T=0;for(w=0;w<=15;w++)R[w]=0;for(b=0;b<n;b++)R[e[a+b]]++;for(m=l,p=15;p>=1&&0===R[p];p--);if(m>p&&(m=p),0===p)return i[r++]=20971520,i[r++]=20971520,o.bits=1,0;for(g=1;g<p&&0===R[g];g++);for(m<g&&(m=g),y=1,w=1;w<=15;w++)if(y<<=1,(y-=R[w])<0)return -1;if(y>0&&(0===t||1!==p))return -1;for(Z[1]=0,w=1;w<15;w++)Z[w+1]=Z[w]+R[w];for(b=0;b<n;b++)0!==e[a+b]&&(s[Z[e[a+b]]++]=b);if(0===t?(A=O=s,u=19):1===t?(A=_e,E-=257,O=fe,T-=257,u=256):(A=ce,O=ue,u=-1),z=0,b=0,w=g,c=r,k=m,v=0,_=-1,f=(x=1<<m)-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){S=w-v,s[b]<u?(U=0,D=s[b]):s[b]>u?(U=O[T+s[b]],D=A[E+s[b]]):(U=96,D=0),h=1<<w-v,g=d=1<<k;do{i[c+(z>>v)+(d-=h)]=S<<24|U<<16|D|0;}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,b++,0==--R[w]){if(w===p)break;w=e[a+s[b]];}if(w>m&&(z&f)!==_){for(0===v&&(v=m),c+=g,y=1<<(k=w-v);k+v<p&&!((y-=R[k+v])<=0);)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;i[_=z&f]=m<<24|k<<16|c-r|0;}}return 0!==z&&(i[c+z]=w-v<<24|64<<16|0),o.bits=m,0};const{Z_FINISH:be,Z_BLOCK:ge,Z_TREES:pe,Z_OK:me,Z_STREAM_END:ke,Z_NEED_DICT:ve,Z_STREAM_ERROR:ye,Z_DATA_ERROR:xe,Z_MEM_ERROR:ze,Z_BUF_ERROR:Ae,Z_DEFLATED:Ee}=q,Re=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function Ze(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0;}const Se=t=>{if(!t||!t.state)return ye;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=1,e.last=0,e.havedict=0,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,me},Ue=t=>{if(!t||!t.state)return ye;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,Se(t)},De=(t,e)=>{let a;if(!t||!t.state)return ye;const n=t.state;return e<0?(a=0,e=-e):(a=1+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?ye:(null!==n.window&&n.wbits!==e&&(n.window=null),n.wrap=a,n.wbits=e,Ue(t))},Oe=(t,e)=>{if(!t)return ye;const a=new Ze;t.state=a,a.window=null;const n=De(t,e);return n!==me&&(t.state=null),n};let Te,Ce,Ne=!0;const Be=t=>{if(Ne){Te=new Int32Array(512),Ce=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(we(1,t.lens,0,288,Te,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;we(2,t.lens,0,32,Ce,0,t.work,{bits:5}),Ne=!1;}t.lencode=Te,t.lenbits=9,t.distcode=Ce,t.distbits=5;},Le=(t,e,a,n)=>{let i;const r=t.state;return null===r.window&&(r.wsize=1<<r.wbits,r.wnext=0,r.whave=0,r.window=new Uint8Array(r.wsize)),n>=r.wsize?(r.window.set(e.subarray(a-r.wsize,a),0),r.wnext=0,r.whave=r.wsize):((i=r.wsize-r.wnext)>n&&(i=n),r.window.set(e.subarray(a-n,a-n+i),r.wnext),(n-=i)?(r.window.set(e.subarray(a-n,a),0),r.wnext=n,r.whave=r.wsize):(r.wnext+=i,r.wnext===r.wsize&&(r.wnext=0),r.whave<r.wsize&&(r.whave+=i))),0};var Ie={inflateReset:Ue,inflateReset2:De,inflateResetKeep:Se,inflateInit:t=>Oe(t,15),inflateInit2:Oe,inflate:(t,e)=>{let a,n,i,r,s,o,l,h,d,_,f,c,u,w,b,g,p,m,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(!t||!t.state||!t.output||!t.input&&0!==t.avail_in)return ye;12===(a=t.state).mode&&(a.mode=13),s=t.next_out,i=t.output,l=t.avail_out,r=t.next_in,n=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=me;t:for(;;)switch(a.mode){case 1:if(0===a.wrap){a.mode=13;break}for(;d<16;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(2&a.wrap&&35615===h){a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=W(a.check,A,2,0),h=0,d=0,a.mode=2;break}if(a.flags=0,a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=30;break}if((15&h)!==Ee){t.msg="unknown compression method",a.mode=30;break}if(d-=4,y=8+(15&(h>>>=4)),0===a.wbits)a.wbits=y;else if(y>a.wbits){t.msg="invalid window size",a.mode=30;break}a.dmax=1<<a.wbits,t.adler=a.check=1,a.mode=512&h?10:12,h=0,d=0;break;case 2:for(;d<16;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(a.flags=h,(255&a.flags)!==Ee){t.msg="unknown compression method",a.mode=30;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=30;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,a.check=W(a.check,A,2,0)),h=0,d=0,a.mode=3;case 3:for(;d<32;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}a.head&&(a.head.time=h),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=W(a.check,A,4,0)),h=0,d=0,a.mode=4;case 4:for(;d<16;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,a.check=W(a.check,A,2,0)),h=0,d=0,a.mode=5;case 5:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&(A[0]=255&h,A[1]=h>>>8&255,a.check=W(a.check,A,2,0)),h=0,d=0;}else a.head&&(a.head.extra=null);a.mode=6;case 6:if(1024&a.flags&&((c=a.length)>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(n.subarray(r,r+c),y)),512&a.flags&&(a.check=W(a.check,n,c,r)),o-=c,r+=c,a.length-=c),a.length))break t;a.length=0,a.mode=7;case 7:if(2048&a.flags){if(0===o)break t;c=0;do{y=n[r+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y));}while(y&&c<o);if(512&a.flags&&(a.check=W(a.check,n,c,r)),o-=c,r+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=8;case 8:if(4096&a.flags){if(0===o)break t;c=0;do{y=n[r+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y));}while(y&&c<o);if(512&a.flags&&(a.check=W(a.check,n,c,r)),o-=c,r+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=9;case 9:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=30;break}h=0,d=0;}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=12;break;case 10:for(;d<32;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}t.adler=a.check=Re(h),h=0,d=0,a.mode=11;case 11:if(0===a.havedict)return t.next_out=s,t.avail_out=l,t.next_in=r,t.avail_in=o,a.hold=h,a.bits=d,ve;t.adler=a.check=1,a.mode=12;case 12:if(e===ge||e===pe)break t;case 13:if(a.last){h>>>=7&d,d-=7&d,a.mode=27;break}for(;d<3;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}switch(a.last=1&h,d-=1,3&(h>>>=1)){case 0:a.mode=14;break;case 1:if(Be(a),a.mode=20,e===pe){h>>>=2,d-=2;break t}break;case 2:a.mode=17;break;case 3:t.msg="invalid block type",a.mode=30;}h>>>=2,d-=2;break;case 14:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=30;break}if(a.length=65535&h,h=0,d=0,a.mode=15,e===pe)break t;case 15:a.mode=16;case 16:if(c=a.length){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;i.set(n.subarray(r,r+c),s),o-=c,r+=c,l-=c,s+=c,a.length-=c;break}a.mode=12;break;case 17:for(;d<14;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=30;break}a.have=0,a.mode=18;case 18:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3;}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=we(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=30;break}a.have=0,a.mode=19;case 19:for(;a.have<a.nlen+a.ndist;){for(;g=(z=a.lencode[h&(1<<a.lenbits)-1])>>>16&255,p=65535&z,!((b=z>>>24)<=d);){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(p<16)h>>>=b,d-=b,a.lens[a.have++]=p;else {if(16===p){for(R=b+2;d<R;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(h>>>=b,d-=b,0===a.have){t.msg="invalid bit length repeat",a.mode=30;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2;}else if(17===p){for(R=b+3;d<R;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}d-=b,y=0,c=3+(7&(h>>>=b)),h>>>=3,d-=3;}else {for(R=b+7;d<R;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}d-=b,y=0,c=11+(127&(h>>>=b)),h>>>=7,d-=7;}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=30;break}for(;c--;)a.lens[a.have++]=y;}}if(30===a.mode)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=30;break}if(a.lenbits=9,E={bits:a.lenbits},x=we(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=30;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=we(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=30;break}if(a.mode=20,e===pe)break t;case 20:a.mode=21;case 21:if(o>=6&&l>=258){t.next_out=s,t.avail_out=l,t.next_in=r,t.avail_in=o,a.hold=h,a.bits=d,de(t,f),s=t.next_out,i=t.output,l=t.avail_out,r=t.next_in,n=t.input,o=t.avail_in,h=a.hold,d=a.bits,12===a.mode&&(a.back=-1);break}for(a.back=0;g=(z=a.lencode[h&(1<<a.lenbits)-1])>>>16&255,p=65535&z,!((b=z>>>24)<=d);){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(g&&0==(240&g)){for(m=b,k=g,v=p;g=(z=a.lencode[v+((h&(1<<m+k)-1)>>m)])>>>16&255,p=65535&z,!(m+(b=z>>>24)<=d);){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}h>>>=m,d-=m,a.back+=m;}if(h>>>=b,d-=b,a.back+=b,a.length=p,0===g){a.mode=26;break}if(32&g){a.back=-1,a.mode=12;break}if(64&g){t.msg="invalid literal/length code",a.mode=30;break}a.extra=15&g,a.mode=22;case 22:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra;}a.was=a.length,a.mode=23;case 23:for(;g=(z=a.distcode[h&(1<<a.distbits)-1])>>>16&255,p=65535&z,!((b=z>>>24)<=d);){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(0==(240&g)){for(m=b,k=g,v=p;g=(z=a.distcode[v+((h&(1<<m+k)-1)>>m)])>>>16&255,p=65535&z,!(m+(b=z>>>24)<=d);){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}h>>>=m,d-=m,a.back+=m;}if(h>>>=b,d-=b,a.back+=b,64&g){t.msg="invalid distance code",a.mode=30;break}a.offset=p,a.extra=15&g,a.mode=24;case 24:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra;}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=30;break}a.mode=25;case 25:if(0===l)break t;if(c=f-l,a.offset>c){if((c=a.offset-c)>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=30;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window;}else w=i,u=s-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{i[s++]=w[u++];}while(--c);0===a.length&&(a.mode=21);break;case 26:if(0===l)break t;i[s++]=a.length,l--,a.mode=21;break;case 27:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=n[r++]<<d,d+=8;}if(f-=l,t.total_out+=f,a.total+=f,f&&(t.adler=a.check=a.flags?W(a.check,i,f,s-f):Y(a.check,i,f,s-f)),f=l,(a.flags?h:Re(h))!==a.check){t.msg="incorrect data check",a.mode=30;break}h=0,d=0;}a.mode=28;case 28:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=n[r++]<<d,d+=8;}if(h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=30;break}h=0,d=0;}a.mode=29;case 29:x=ke;break t;case 30:x=xe;break t;case 31:return ze;case 32:default:return ye}return t.next_out=s,t.avail_out=l,t.next_in=r,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<30&&(a.mode<27||e!==be))&&Le(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,a.wrap&&f&&(t.adler=a.check=a.flags?W(a.check,i,f,t.next_out-f):Y(a.check,i,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(12===a.mode?128:0)+(20===a.mode||15===a.mode?256:0),(0===_&&0===f||e===be)&&x===me&&(x=Ae),x},inflateEnd:t=>{if(!t||!t.state)return ye;let e=t.state;return e.window&&(e.window=null),t.state=null,me},inflateGetHeader:(t,e)=>{if(!t||!t.state)return ye;const a=t.state;return 0==(2&a.wrap)?ye:(a.head=e,e.done=!1,me)},inflateSetDictionary:(t,e)=>{const a=e.length;let n,i,r;return t&&t.state?0!==(n=t.state).wrap&&11!==n.mode?ye:11===n.mode&&(i=Y(i=1,e,a,0))!==n.check?xe:(r=Le(t,e,a,a))?(n.mode=31,ze):(n.havedict=1,me):ye},inflateInfo:"pako inflate (from Nodeca project)"};var Fe=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1;};const Me=Object.prototype.toString,{Z_NO_FLUSH:He,Z_FINISH:je,Z_OK:Ke,Z_STREAM_END:Pe,Z_NEED_DICT:Je,Z_STREAM_ERROR:Ye,Z_DATA_ERROR:Ge,Z_MEM_ERROR:We}=q;function Xe(t){this.options=Yt.assign({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new qt,this.strm.avail_out=0;let a=Ie.inflateInit2(this.strm,e.windowBits);if(a!==Ke)throw new Error(X[a]);if(this.header=new Fe,Ie.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Xt.string2buf(e.dictionary):"[object ArrayBuffer]"===Me.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Ie.inflateSetDictionary(this.strm,e.dictionary))!==Ke))throw new Error(X[a])}function qe(t,e){const a=new Xe(e);if(a.push(t),a.err)throw a.msg||X[a.err];return a.result}Xe.prototype.push=function(t,e){const a=this.strm,n=this.options.chunkSize,i=this.options.dictionary;let r,s,o;if(this.ended)return !1;for(s=e===~~e?e:!0===e?je:He,"[object ArrayBuffer]"===Me.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(n),a.next_out=0,a.avail_out=n),(r=Ie.inflate(a,s))===Je&&i&&((r=Ie.inflateSetDictionary(a,i))===Ke?r=Ie.inflate(a,s):r===Ge&&(r=Je));a.avail_in>0&&r===Pe&&a.state.wrap>0&&0!==t[a.next_in];)Ie.inflateReset(a),r=Ie.inflate(a,s);switch(r){case Ye:case Ge:case Je:case We:return this.onEnd(r),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||r===Pe))if("string"===this.options.to){let t=Xt.utf8border(a.output,a.next_out),e=a.next_out-t,i=Xt.buf2string(a.output,t);a.next_out=e,a.avail_out=n-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(i);}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(r!==Ke||0!==o){if(r===Pe)return r=Ie.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,!0;if(0===a.avail_in)break}}return !0},Xe.prototype.onData=function(t){this.chunks.push(t);},Xe.prototype.onEnd=function(t){t===Ke&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Yt.flattenChunks(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg;};var Qe={Inflate:Xe,inflate:qe,inflateRaw:function(t,e){return (e=e||{}).raw=!0,qe(t,e)},ungzip:qe,constants:q};const{Deflate:Ve,deflate:$e,deflateRaw:ta,gzip:ea}=he,{Inflate:aa,inflate:na,inflateRaw:ia,ungzip:ra}=Qe;var sa={Deflate:Ve,deflate:$e,deflateRaw:ta,gzip:ea,Inflate:aa,inflate:na,inflateRaw:ia,ungzip:ra,constants:q};function oa(t){try{for(;t.length%4!=0;)t+="=";var e=f.toByteArray(t),a=sa.inflate(e),n=new TextDecoder("utf-8");return JSON.parse(n.decode(a))}catch(t){return null}}function la(t){try{var e=Buffer.from(t,"base64").toString("utf-8");return JSON.parse(e)}catch(t){return null}}function ha(t){try{return JSON.parse(atob(t))}catch(t){return null}}t.decodeJzb=oa,t.decodeJzbMultipleMethods=function(t){var e=ha(t);return e||(e=la(t)),e||(e=oa(t)),e},t.decodeJzbWithBuffer=la,t.parseJSONKey=ha,Object.defineProperty(t,"__esModule",{value:!0});});
});

const ALLOWED_DOMAINS = ['pendo.io', 'pendo-dev.com', 'pendo.local'];

const ALLOWED_DOMAIN_REGEX = new RegExp(`(:?${ALLOWED_DOMAINS.map(domain => domain.replace(/\./g, '\\.')).join('|')})$`);
function isSafeRedirectUrl(urlOrPath) {
  const url = new URL(urlOrPath, window.location.origin);
  return ALLOWED_DOMAIN_REGEX.test(url.hostname);
}

//
const EMAIL_PARAM = 3;
const INVITE_KEY_PARAM = 4;
var script$2 = {
  name: 'CreateAccount',
  components: {
    PendoButton,
    PendoAlert,
    SetPasswordForm: __vue_component__$3,
    LoginTemplate: __vue_component__$d
  },
  props: {
    /**
     * If the domain is a white label domain
     */
    isWhiteLabel: {
      type: Boolean,
      default: false
    },
    time: {
      type: Date,
      default: () => new Date()
    },
    storybookMock: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFormValid: false,
      isSubmitting: false,
      submissionError: null,
      isExpiredInviteKey: false,
      isBadInviteKey: false,
      isLoading: false
    };
  },

  computed: {
    isNight() {
      const useNightMode = this.time ? isNightTime(this.time) : false;
      return !this.isWhiteLabel && useNightMode;
    },

    pathnameStrings() {
      return window.location.pathname.split('/');
    },

    userEmail() {
      if (this.pathnameStrings.length > EMAIL_PARAM) {
        return decodeURIComponent(this.pathnameStrings[EMAIL_PARAM]);
      }

      return null;
    },

    isUserCreated() {
      return this.urlparam('type') === 'setup' || this.urlparam('after') === 'post-register-steps';
    },

    hiUser() {
      return this.userEmail && !this.storybookMock ? `Hi, ${this.userEmail}` : 'Hi, user';
    },

    inviteKey() {
      if (this.pathnameStrings.length > INVITE_KEY_PARAM) {
        return this.pathnameStrings[INVITE_KEY_PARAM];
      }

      return null;
    },

    search() {
      const here = new URL(window.location.href);
      return here.search;
    },

    versionQueryParam() {
      const versionParam = this.urlparam('version');
      return versionParam ? `?version=${versionParam}` : '';
    }

  },

  async created() {
    if (this.storybookMock) {
      return;
    }

    this.isLoading = true;
    await this.getInfoFromInviteKey();
    this.isLoading = false;
  },

  methods: {
    async getInfoFromInviteKey() {
      const invite = DecodeJzb.decodeJzbMultipleMethods(this.inviteKey);

      if (!invite) {
        await this.getInfoFromApi();
        return;
      }

      const now = new Date().getTime();
      this.isExpiredInviteKey = now > invite.Expires * 1000;

      if (this.isExpiredInviteKey) {
        window.location.assign('/invitation-expired');
      }
    },

    async getInfoFromApi() {
      try {
        const response = await getInvitationInfo(this.inviteKey);
        const invite = get(response, 'data', {});
        const now = new Date().getTime();
        this.isExpiredInviteKey = now > invite.ExpiresAt;

        if (this.isExpiredInviteKey) {
          window.location.assign('/invitation-expired');
        }
      } catch (error) {
        this.isBadInviteKey = true;
        const {
          data,
          status
        } = error.response;
        const statusCode = parseInt(status);
        const errorMsg = (typeof data === 'string' ? data : get(data, 'message', 'error')).trim();
        routeToError({
          statusCode,
          errorMsg
        });
      }
    },

    async registerGoogle() {
      this.isFormValid = true;
      this.submissionError = null;

      if (this.storybookMock) {
        this.$emit('storybook-register-google-clicked');
        return;
      }

      this.isSubmitting = true;

      try {
        if (this.isUserCreated) {
          window.location.href = `/login/google${this.search}`;
        } else {
          const {
            url
          } = await createWithGoogle(this.inviteKey);
          window.location.href = url;
        }
      } catch (error) {
        this.isSubmitting = false;
        this.submissionError = get(error, 'response.data', error);
      }
    },

    validatePasswordForm() {
      this.$refs.passwordForm.validateForm({
        submitOnValid: true
      });
    },

    onInvalidPasswordForm() {
      this.isFormValid = false;
    },

    urlHasPath(urlOrPath) {
      try {
        return new URL(urlOrPath, window.location.origin).pathname !== '/';
      } catch {
        return false;
      }
    },

    async onValidPasswordForm(_ref) {
      let {
        model,
        submit
      } = _ref;
      this.isFormValid = true;

      if (this.storybookMock) {
        this.$emit('storybook-submit-clicked', model);
        return;
      }

      if (submit) {
        this.isSubmitting = true;
        this.submissionError = null;

        try {
          if (this.isUserCreated) {
            await resetPassword(this.inviteKey, model.password);
          } else {
            const {
              redirect
            } = await createWithPassword(this.inviteKey, model.password);

            if (redirect && this.urlHasPath(redirect)) {
              window.location.href = redirect;
              return;
            }
          }

          const afterParam = this.urlparam('after');

          if (afterParam && isSafeRedirectUrl(afterParam)) {
            window.location.assign(`/${afterParam}${this.versionQueryParam}`);
          } else {
            window.location.assign('/');
          }
        } catch (error) {
          this.isSubmitting = false;
          this.submissionError = get(error, 'response.data', error);
        }
      }
    },

    urlparam(param) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(param) || '';
    },

    removeErrors() {
      this.submissionError = null;
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.storybookMock || !_vm.isBadInviteKey && !_vm.isExpiredInviteKey && !_vm.isLoading ? _c('login-template', {
    attrs: {
      "is-white-label": _vm.isWhiteLabel,
      "time": _vm.time,
      "title": "Create your account",
      "description": ""
    },
    on: {
      "on-focus": _vm.removeErrors
    },
    scopedSlots: _vm._u([{
      key: "form",
      fn: function () {
        return [_c('p', {
          staticClass: "helper-text",
          class: {
            'helper-text-night': _vm.isNight,
            'helper-text-password-only': _vm.isWhiteLabel
          }
        }, [_vm._v("\n            " + _vm._s(_vm.hiUser) + "\n        ")]), _vm._v(" "), !_vm.isWhiteLabel ? _c('a', {
          staticClass: "google-login",
          attrs: {
            "target": "_self"
          },
          on: {
            "click": _vm.registerGoogle
          }
        }) : _vm._e(), _vm._v(" "), !_vm.isWhiteLabel ? _c('div', {
          staticClass: "option-separator",
          class: {
            'option-separator-night': _vm.isNight
          }
        }, [_vm._v("\n            OR\n        ")]) : _vm._e(), _vm._v(" "), _vm.submissionError ? _c('pendo-alert', {
          staticClass: "submit-error",
          attrs: {
            "title": "An error occurred",
            "description": _vm.submissionError,
            "type": "error"
          }
        }) : _vm._e(), _vm._v(" "), _c('set-password-form', {
          ref: "passwordForm",
          attrs: {
            "reset-password": false,
            "is-white-label": _vm.isWhiteLabel,
            "is-night": _vm.isNight
          },
          on: {
            "valid": _vm.onValidPasswordForm,
            "invalid": _vm.onInvalidPasswordForm,
            "on-focus": _vm.removeErrors
          }
        }), _vm._v(" "), _c('pendo-button', {
          attrs: {
            "type": "primary",
            "theme": "app",
            "block": "",
            "label": "Create account",
            "disabled": !_vm.isFormValid || _vm.isSubmitting,
            "loading": _vm.isSubmitting
          },
          on: {
            "click": _vm.validatePasswordForm
          }
        })];
      },
      proxy: true
    }, {
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }, {
      key: "nightLogo",
      fn: function () {
        return [_vm._t("nightLogo")];
      },
      proxy: true
    }], null, true)
  }) : _vm._e();
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-dd0b8a9a_0", {
    source: ".pendo-button.is-block[data-v-dd0b8a9a]{display:flex;margin-top:25px}.google-login[data-v-dd0b8a9a]{margin-bottom:25px;display:inherit;width:inherit;height:40px;background:#fff center no-repeat url(https://cdn.pendo.io/img/google-signin.svg);border-radius:3px;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.24),0 0 2px 0 rgba(0,0,0,.12)}.google-login[data-v-dd0b8a9a]:hover{cursor:pointer;background-color:#f4f4f7;border:none;box-shadow:0 2px 2px 0 rgba(0,0,0,.24),0 0 2px 0 rgba(0,0,0,.12)}.helper-text[data-v-dd0b8a9a]{font-size:18px;font-weight:400;margin:-1.5em auto 1em;text-align:center}.helper-text-password-only[data-v-dd0b8a9a]{margin-bottom:2.5em}.helper-text-night[data-v-dd0b8a9a]{color:#f4f4f7}.option-separator[data-v-dd0b8a9a]{font:400 14px/1em Inter;color:#9a9ca5;margin:30px auto;text-align:center}.option-separator-night[data-v-dd0b8a9a]{color:#fff}.submit-error[data-v-dd0b8a9a]{margin-bottom:1em}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$2 = "data-v-dd0b8a9a";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
var script$1 = {
  name: 'ResetPassword',
  components: {
    PendoAlert,
    PendoButton,
    PendoCard,
    SetPasswordForm: __vue_component__$3,
    LoginBackground: __vue_component__$e
  },

  data() {
    return {
      isFormValid: false,
      isSubmitting: false,
      submissionError: null
    };
  },

  computed: {
    submitButtonLabel() {
      return 'Reset password';
    },

    setPasswordHeading() {
      return 'Reset your password';
    },

    inviteKey() {
      const pathnameStrings = window.location.pathname.split('/');

      if (pathnameStrings.length > 4) {
        return pathnameStrings[4];
      }

      return null;
    },

    versionQueryParam() {
      const versionParam = this.urlparam('version');
      return versionParam ? `?version=${versionParam}` : '';
    }

  },
  methods: {
    validatePasswordForm() {
      this.$refs.passwordForm.validateForm({
        submitOnValid: true
      });
    },

    onInvalidPasswordForm() {
      this.isFormValid = false;
    },

    async onValidPasswordForm(_ref) {
      let {
        model,
        submit
      } = _ref;
      this.isFormValid = true;

      if (submit) {
        this.isSubmitting = true;
        this.submissionError = null;

        if (!this.inviteKey) {
          this.submissionError = 'Invite key does not exist';
          this.isSubmitting = false;
          return;
        }

        try {
          await resetPassword(this.inviteKey, model.password);
          window.location.assign(`/${this.urlparam('after')}${this.versionQueryParam}`);
        } catch (error) {
          this.isSubmitting = false;
          this.submissionError = get(error, 'response.data', error);
        }
      }
    },

    urlparam(param) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(param) || '';
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('login-background', {
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }], null, true)
  }, [_c('pendo-card', {
    attrs: {
      "body-min-height": "0",
      "footer-min-height": "0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('h2', {
          staticClass: "password__title"
        }, [_vm._v("\n                " + _vm._s(_vm.setPasswordHeading) + "\n            ")]), _vm._v(" "), _vm.submissionError ? _c('pendo-alert', {
          staticClass: "password__error",
          attrs: {
            "title": "An error occurred",
            "description": _vm.submissionError,
            "type": "error"
          }
        }) : _vm._e(), _vm._v(" "), _c('set-password-form', {
          ref: "passwordForm",
          attrs: {
            "reset-password": ""
          },
          on: {
            "valid": _vm.onValidPasswordForm,
            "invalid": _vm.onInvalidPasswordForm
          }
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('pendo-button', {
          attrs: {
            "type": "primary",
            "theme": "app",
            "block": "",
            "label": _vm.submitButtonLabel,
            "disabled": !_vm.isFormValid || _vm.isSubmitting,
            "loading": _vm.isSubmitting
          },
          on: {
            "click": _vm.validatePasswordForm
          }
        })];
      },
      proxy: true
    }])
  })], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-53485e32_0", {
    source: ".password__title[data-v-53485e32]{margin:0 0 16px;font-size:22px;line-height:36px;font-weight:700}.password__error[data-v-53485e32]{margin-bottom:24px}.pendo-card[data-v-53485e32]{width:400px;display:flex;flex-direction:column;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,.17);border-radius:3px;z-index:1}.pendo-card[data-v-53485e32]  .pendo-card__body{padding:24px}.pendo-card[data-v-53485e32] .pendo-card__footer{padding:16px 24px}.pendo-card .pendo-button.is-block[data-v-53485e32]{display:flex}@media only screen and (max-width:767px){.pendo-card[data-v-53485e32]{margin-top:25px}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1 = "data-v-53485e32";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
var script = {
  name: 'CreatePassword',
  components: {
    ResetPassword: __vue_component__$1,
    CreateAccount: __vue_component__$2
  },
  props: {
    /**
     * If the domain is a white label domain
     */
    isWhiteLabel: {
      type: Boolean,
      default: false
    },
    storybookMock: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSetup() {
      return this.storybookMock || this.urlparam('type') === 'setup' || this.urlparam('after') === 'post-register-steps';
    }

  },
  methods: {
    urlparam(param) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(param) || '';
    },

    registerGoogle() {
      this.$emit('storybook-register-google-clicked');
    },

    submitForm(val) {
      this.$emit('storybook-submit-clicked', val);
    }

  }
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.isSetup ? _c('create-account', {
    attrs: {
      "storybook-mock": _vm.storybookMock,
      "is-white-label": _vm.isWhiteLabel
    },
    on: {
      "storybook-submit-clicked": _vm.submitForm,
      "storybook-register-google-clicked": _vm.registerGoogle
    },
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }, {
      key: "nightLogo",
      fn: function () {
        return [_vm._t("nightLogo")];
      },
      proxy: true
    }], null, true)
  }) : _c('reset-password', {
    scopedSlots: _vm._u([{
      key: "logo",
      fn: function () {
        return [_vm._t("logo")];
      },
      proxy: true
    }], null, true)
  });
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function interceptRequest(config) {
  const configClone = cloneDeep(config); // we can remove this once adopt v2 migration is complete

  configClone.headers['x-adopt-v2'] = true;
  return configClone;
}
/* Set up config and hooks for using @pendo/http wrapper:
    import {http} from '@pendo/http';
    http.get('https://app.pendo.io/api/_SID_/user/_UID_');
*/

function initializeHttpWrapper() {
  initializeHttpWrapper$1({
    retryCount: 3,
    retryDelay: 500,
    interceptRequestExtensionHandler: interceptRequest,
    logout: () => false,
    getUserId: () => null,
    getSubscriptionId: () => null,
    getSubscriptionName: () => null
  });
}

initializeHttpWrapper();
Vue.use(VueCookies);

if (!Vue.prototype.$t) {
  Vue.prototype.$t = mock$T;
}

export { __vue_component__$4 as AcceptInvite, __vue_component__$2 as CreateAccount, __vue_component__ as CreatePassword, __vue_component__$9 as ExpiredLink, __vue_component__$c as ForgotPassword, __vue_component__$6 as InvitationError, __vue_component__$8 as Login, __vue_component__$e as LoginBackground, __vue_component__$7 as NoActiveSubs };
